import { A, D, DELETE, O, PERIOD, T } from "@angular/cdk/keycodes";
import { shooting } from "../models/easydiadem/requests/packshot.model";
import { VERSION } from "lodash";
import { CANCELLED, FILE } from "dns";

export const fr = {
    _NONE: "-",
    WELCOME: "Bienvenue",
    AUTOMATIC_ARCHIVE: "Archivage automatique",
    NO_BRANDS: "Aucune marque",
    BRANDS: "marques",
    ARCHIVE: "Archiver",
    NOT_MODIFIED_SINCE: "Dernière modification",
    BRANDS_CLIENT: "Marque(s) client",
    BRANDS_LIST: "Liste des marques",
    RELECTURE_EXTERN: "Relecture",
    RELECTURE_INTERN: "Relecture interne",
    LAST_REVISION: "Dernière revision",
    ARCHIVED: "Archivé",
    FROM_ARCHIVE: "Depuis l'archive",
    SHOW_ARCHIVED_VERSION: "Versions de l'archive",
    PR_UPDATED: "Relecture mise à jour.",
    RETURN: "Retour",
    LANGUAGES: "Langues",
    I_UNDERSTAND: "J'ai compris",
    CANCELLED: "Annulé",
    CANCEL_FULLSCREEN: "Réduire",
    INFORMATION: "Informations",
    ASSERT_INFORMATIONS: "Les informations ci-dessous sont-elles toujours exactes ?",
    COMMENTARY: "Commentaires",
    COMMENTARY_PLACEHOLDER: "Indiquez ici les changements à apporter",
    RELECTURE_MEMBERS: "Membres pour relecture",
    MAIN_MEMBER: "Demandeur",
    TODO: "A verifier",
    DONE: "Fait",
    DOWNLOAD: "Télécharger",
    PDF_CAN_REUPLOAD: "Vous pouvez charger un nouveau fichier PDF",
    UPLOAD: "Charger",
    PDF_PLEASE_REUPLOAD: "Veuillez charger un nouveau fichier PDF",
    OLD_PROJECT: "Projet limité",
    OLD_PROJECT_NO_PR: "ancien projet",
    REORDER: "Réordonner",
    CURRENT_ORDER: "Ordre courant : ",
    EDIT_MEMBERS: "Modifier les membres",
    ALREADY_EXISTS: "Existe déjà",
    DECISION_TAKEN_BY: "par : ",
    RESERVED_KEYWORD: "Mot clé réservé",
    NOT_ALLOWED_ON_ARCHIVED: "Action non autorisée sur un projet archivé",
    NOT_ALLOWED_ON_ARCHIVE_PENDING: "Action indisponible : un archivage ou un désarchivage est programmé sur ce projet",
    SELECT_A_CUSTOMER_OR_CHOOSE_ALL_CUSTOMER: "Sélectionnez un client ou choisissez tous les clients",
    SAVE_SUCCESS: "Sauvegarde réussie",
    BAT: "BAT",
    BAT_LINK: "Voir le BAT",
    FORM: {
        "TEXT-CORRECTION": "Correction de texte",
        "PDF-REPOSITORY": "PDF",
        "FILE-REDELIVERY": "Relivraison de fichiers",
        HEADS: {
            PLAN: "Plan",
            CUSTOMER_BRIEF: "Brief Client",
            BAT: "BAT",
            COLOUR: "Couleur",
            CREA_FILES: "Fichiers Créa",
            IMAGES_TO_RETOUCH: "Images à retoucher",
            TECHNICAL_PLAN: "Plan technique",
            TEXT_SHEET: "Fiche texte",
            PRINTING_METHOD: "Méthode d'impression",
            COLORING: "Mise en couleur",
            BRAND_CHART: "Charte de marque",
            DEADLINE: "Délai",
            VALIDATION_CYCLE: "Cycle de validation",
            CLIENT_CONTACT: "Contact client",
            CONTACT: "Contact",
            ARCHIVE_EXISTING_REFERENCE: "Archive référence existante",
            SOURCE_PROJECT: "Archive concernée",
            PRINTER: "Impression",
            SEQ_COLORS: "Séquence d'impression",
            TEXT: "Fiche textes",
            RELECTURE: "Membres pour relecture",
            FINALIZATION: "Finalisation",
            EPSON_CONTACT: "Contact",

            GENERAL_INFO: "Informations projet maître",
            L2PUB: "Identifiant projet",
            GENERAL: "Informations générales",
            MEMBERS: "Membres",
            TEAM_CREATIF_MEMBERS: "Approbateurs Team Créatif",
            INTERNAL_MEMBERS: "Approbateurs Team Créatif",
            COLORS: "Mise en couleurs",

            NAME: "Informations",
            QUANTITY: "Quantité",
            NUM_JOB: "Numéro de job",
            FILES: "Fichier",
            FILE: "Fichier",
            DESCRIPTION: "Description",
            SHOOTING: "Prises de vue",
            REDELIVERYTYPE: "Type de relivraison",
            BASE: "Base de travail",
            PRINTING: "Impression",
            CODES: "Codes (QRCode, Gencod...)",
            CARTOUCHE: "Cartouche",
            CREA: "CREA",
            EXE: "EXE",
            REPRO: "REPRO",
            HD: "HD",
            PDF_REPO: "Dépôt de PDF",

            PROOFREADING_ID: "Sélectionnez un flux", // Apparaît comme une sélection de flux pour l'utilisateur
            OTHER: "Autre"
        },
        ERRORS: {
            GENERAL_INFO: {
                CPP: "Veuillez choisir un CPP",
                CUSTOMER: "Veuillez choisir un client",
                MARQUE: "Veuillez choisir une marque",
                DESIGNATION: "Veuillez choisir une désignation",
                CONTACT: "Veuillez choisir un contact",
                FAMILY: "Veuillez choisir une famille",
                L2PUB: "Veuillez choisir un identifiant projet"
            },
            L2PUB: "Veuillez choisir un identifiant projet",
            GENERAL: {
                FLOWS: "Veuillez choisir un flux",
                SERVICE_EXE: "Veuillez choisir un flux",
                SERVICE_HD: "",
                SERVICE_REPRO: "",
                SERVICE_OTHER: "",
                SERVICE_REPO: "",
                DESIGNATION: "Veuillez choisir une désignation",
                CATEGORY: "Veuillez choisir une catégorie",
                SUB_CATEGORY: "Veuillez choisir une sous-catégorie",
                ID_JOBTEAM: "Numéro Team Créatif invalide"
            },
            PRINTING: {
                PRINTER: "Veuillez choisir un imprimeur",
                PROCESS: "Veuillez choisir un process",
                SUPPORT: "Veuillez choisir un support",
                PLAN_TECHNIQUE: "Veuillez choisir un plan"
            },
            MEMBERS: "Veuillez choisir un membre \n approbateur du document / information",
            NAME: "Veuillez nommer votre projet",
            FILES: "Veuillez choisir un fichier",
            RELECTURE: {
                MEMBERS: "Veuillez choisir un membre"
            },
            SOURCE_PROJECT: {
                IDENTIFIER: "Veuillez indiquer le projet concerné"
            },
            PLAN: {
                FILE_PLAN: "Veuillez choisir un fichier"
            },
            FINALIZATION: {
                RESPONSABILITY_AGREEMENT: "Veuillez accepter les conditions"
            },
            QUANTITY: "Veuillez indiquer une quantité",
            EPSON_CONTACT: {
                FIRSTNAME: "Veuillez indiquer un prénom",
                LASTNAME: "Veuillez indiquer un nom",
                TEL: "Veuillez indiquer un numéro de téléphone",
                EMAIL: "Veuillez indiquer un email",

                ADDRESS: {
                    STREET: "Veuillez indiquer une adresse",
                    CP: "Veuillez indiquer un code postal",
                    CITY: "Veuillez indiquer une ville"
                }
            },
            REDELIVERYTYPE: "Veuillez indiquer un type de relivraison",
            DESCRIPTION: "Veuillez indiquer une description",
            SHOOTING: "Veuillez indiquer une prise de vue",
            SEQ_COLORS: {
                COMMENT: "Veuillez indiquer un commentaire \n pour la séquence d'impression"
            },
            PRINTER: {
                COMMENT: "Veuillez indiquer un commentaire \n concernant l'imprimeur"
            },
            CODES: {
                GENCOD: {
                    CODE: "Veuillez indiquer un code valide"
                }
            },
            COLORS: {
                IMPRESSION_COULEUR1: "Veuillez indiquer une couleur 1 valide",
                IMPRESSION_COULEUR2: "Veuillez indiquer une couleur 2 valide",
                IMPRESSION_COULEUR3: "Veuillez indiquer une couleur 3 valide",
                IMPRESSION_COULEUR4: "Veuillez indiquer une couleur 4 valide",
                IMPRESSION_COULEUR5: "Veuillez indiquer une couleur 5 valide",
                IMPRESSION_COULEUR6: "Veuillez indiquer une couleur 6 valide",
                IMPRESSION_COULEUR7: "Veuillez indiquer une couleur 7 valide",
                IMPRESSION_COULEUR8: "Veuillez indiquer une couleur 8 valide",
                IMPRESSION_COULEUR9: "Veuillez indiquer une couleur 9 valide",
                IMPRESSION_COULEUR10: "Veuillez indiquer une couleur 10 valide",
                IMPRESSION_FINITION1: "Veuillez indiquer une finition 1 valide",
                IMPRESSION_FINITION2: "Veuillez indiquer une finition 2 valide",
                IMPRESSION_FINITION3: "Veuillez indiquer une finition 3 valide",
                IMPRESSION_FINITION4: "Veuillez indiquer une finition 4 valide",
                IMPRESSION_FINITION5: "Veuillez indiquer une finition 5 valide",
                IMPRESSION_FINITION6: "Veuillez indiquer une finition 6 valide",
                IMPRESSION_FINITION7: "Veuillez indiquer une finition 7 valide",
                IMPRESSION_FINITION8: "Veuillez indiquer une finition 8 valide",
                IMPRESSION_FINITION9: "Veuillez indiquer une finition 9 valide",
                IMPRESSION_FINITION10: "Veuillez indiquer une finition 10 valide"
            },
            CONTACT: "Veuillez indiquer une adresse",
            PDF_REPO: {
                FILE_REPO: "Veuillez choisir un fichier"
            },
            BAT: {
                FILE_BAT: "Veuillez choisir un fichier"
            }
        },
        ADD_FILE_UPLOADER: "Ajouter un fichier",
        REMOVE_FILE_UPLOADER: "Supprimer le fichier",
        REUPLOAD_FILE: "Recharger le fichier (incrémentera la version)"
    },
    PDF_REPO: "PDF",

    PDF_REPO_FLOW: {
        LEGEND: "Chaque fichier déposé entraînera automatiquement une relecture",
        LINK: "Voir la relecture"
    },
    ASSESSMENT: {
        PENDING: "En attente",
        APPROVE: "Approuvé",
        REJECT: "Rejeté",
        IN_PROGRESS: "Att. approbation",
        READONLY: "Lecture seule",
        READONLY_PROOFSCOPE: "Consultation",
        PAUSED: "Cycle en pause"
    },
    STATE: "État",
    APPROVAL_SENT: "Approbation reçues",
    SEE_ALL: "Tout voir",
    ADDRESS: {
        ADDRESS: "Adresse",
        LASTNAME: "Nom",
        FIRSTNAME: "Prénom",
        STREET: "Adresse (numéro et rue)",
        CITY: "Ville",
        CP: "Code postal",
        EMAIL: "Adresse e-mail",
        TEL: "Téléphone"
    },
    FEATURE_TO_COME: "Fonctionnalité(s) à venir",
    RECENT_PROJECTS: "Historique",
    LAST_10_ENTRIES: "10 dernières entrées",
    HI_DESCRIPTION:
        "Quels élements souhaitez-vous mettre en avant sur votre Hero Image?  (il sera livré aux formats jpeg, png - Basse déf et Haute déf) : ",
    CLOSED: "Clôturé",
    FULL_SCREEN: "Plein écran",
    NO_FULL_SCREEN: "Ecran normal",
    COMPARE_DOC_A: "Document A",
    COMPARE_DOC_B: "Document B",
    COMPARE_DOC: "Document",
    COMPARE_CURRENT: "(version actuelle)",
    CREATE_PROOFREADING: "Créer une relecture",
    SELECT_FLOW: "Sélectionnez un type de flux",
    SELECT_FLOW_ARE_YOU_SURE: "La création d'une nouvelle proofreading effacera les données non sauvegardées. Voulez-vous continuer ?",
    PROOFREADING_MISSING: "La relecture désirée n'existe pas",
    FLOW: "Flux",
    EXE: "EXE",
    REPRO: "REPRO",
    CREA: "CREA",
    HD: "HD",
    REQUEST_UPDATED: "Requête mise à jour",
    EZD_EXE: "EZD - EXE",
    EZD_PDF_REPOSITORY: "EZD - PDF",
    INFORMATIONS: "Informations",
    READ_ONLY_APPROVER: "Approbateur en lecture seule",
    PRODUCTION_TEXTS: {
        ERROR_SAVING: "Vous n'avez pas la permission de sauvegarder les textes de production",
        CREATE_MODIFY: "Modifier / Créer fiche Texte",
        INSTRUCTIONS: "Ecrire les instructions",
        UPLOAD: "Dépôt de fiche textes",
        OPEN: "Ouvrir",
        NAME: "Fiche Textes",
        ADD: "Ajouter une fiche texte",
        ARE_YOU_SURE_ADD: "Voulez-vous ajouter une fiche texte ?",
        ARE_YOU_SURE_REMOVE: "Voulez-vous supprimer ce champ texte ?",
        MANAGE_LANG: "Langues",
        PREFILL: "Préremplir",
        ADD_FIELD: "Ajouter un champ",
        FIELD_NAME: "Nom du champ",
        LABEL: "Libellé",
        FACING: "Facing",
        BACK: "Dos + côtés",
        FIELD_PLACEHOLDER: "Entrez le nom du champ",
        LEGAL: "Textes légaux",
        MARKETING: "Textes marketing",
        TVN: "TVN",
        SAVED: "Fiche texte sauvegardée",
        REMOVED: "Champ texte supprimé",
        PREFILL_SELECT_REF: "Sélectionnez une référence",
        PREFILL_SELECT_REF_TEXT:
            "Cet action va remplacer le contenu de la fiche texte par celui de la référence sélectionnée. Voulez-vous continuer ?",
        PREFILL_SELECT_REF_PLACEHOLDER: "PXXXXXX",
        AI_AUTOCOMPLETE: "IA Préremplir",
        AI_TAB_SERVER: "Fichier du projet",
        AI_TAB_UPLOAD: "Déposer un PDF",
        AI_LOADING: "Analyse en cours...",
        AI_SUCCESS: "Fiche texte complétée par l'IA",
        AI_ERROR: "Erreur lors de l'analyse par l'IA",
        AI_NO_FILE: "Aucun fichier PDF associé à cette relecture",
        AI_DIALOG_TEXT: "Sélectionnez la source du fichier PDF à analyser",
        AI_DROP_TEXT: "Glissez-déposez un PDF ici ou cliquez pour parcourir",
        AI_SUBMIT: "Analyser",
        AI_DISCLAIMER: "L'IA peut faire des erreurs. Veuillez vérifier les résultats avant de sauvegarder."
    },
    TVN: {
        ADD_FIELD: "Ajouter un champ"
    },
    BRAND: {
        MANAGE: "Gestion des marques",
        BACK_TO_TABLE: "Retour à la table des marques",
        UPDATE: "Mettre à jour",
        LABEL: "Nom",
        EDIT: "Editer la marque",
        MANAGE_EZD_FLAGS: "Gestion des droits EasyDiadem",
        MANAGE_SFTP: "Gestion SFTP",
        MANAGE_FLAGS: "Gestion des drapeaux",
        ENABLE_EASYDIADEM: "Activer EasyDiadem",
        ENABLE_CATEGORIES: "Activer les catégories",
        ENABLE_ATTACHMENTS: "Autoriser les utilisateurs de la marque à ajouter des pièces jointes lors des relectures",
        ENABLE_SFTP: "Activer Sftp",
        SAVE_SFTP_CONFIG: "Sauvegarder la configuration SFTP",
        MANAGE_THEME: "Couleurs de la marque client",
        TOPBAR_BACKGROUND: "Couleur principale",
        TOPBAR_TEXT: "Couleur secondaire",
        ACCENT_COLOR: "Couleur d'accentuation",
        THEME_HELP: "Ces couleurs s'appliquent uniquement aux utilisateurs clients mono-marque. Laissez vide pour conserver les couleurs par défaut.",
        SAVE_THEME: "Sauvegarder les couleurs",
        MANAGE_LOGO: "Image de la marque",
        LOGO_HELP: "Cette image est convertie en PNG puis stockée dans PP_FILE_STORE/Public/logos pour la topbar client.",
        NO_LOGO: "Aucune image trouvée pour cette marque",
        SHOW_LOGO_IN_TOPBAR: "Afficher ce logo dans la topbar client",
        SHOW_LOGO_PADDING_IN_TOPBAR: "Ajouter un fond/padding autour du logo de marque",
        SHOW_DIADEM_LOGO_IN_TOPBAR: "Afficher le logo DIADEM LiveCo dans la topbar client",
        SHOW_TEAM_CREATIF_LOGO_IN_TOPBAR: "Afficher le logo Team Créatif dans la topbar client",
        SELECT_LOGO: "Choisir une image",
        SAVE_LOGO_SETTINGS: "Sauvegarder les paramètres du logo",
        SAVE_LOGO: "Sauvegarder l'image",
        LOGO_UPLOAD_SUCCESS: "Image de marque sauvegardée",
        LOGO_INVALID_FILE: "Veuillez sélectionner une image",
        MANAGE_CATEGORIES_FLAGS: "Gestion des catégories",
        BRAND_USERS: "Utilisateurs de la marque",
        EMPLTY_MEANS_ALL: "Laisser vide active toutes les requêtes",
        KNOW_WHAT_YOU_DO_WARNING: "Attention, ne modifiez cette section seulement si vous savez ce que vous faites.",
        FLAGS: {
            SELECT_REQUEST_TYPES: "Sélectionnez les types de requêtes",
            SAVE: "Sauvegarder les drapeaux",
            SAVE_EZD: "Sauvegarder les droits EZD",
            SAVE_CATEGORIES: "Sauvegarder les catégories",
            SAVE_ATTACHMENTS: "Sauvegarder",
            PLACEHOLDER: "Ecivez le nom d'un flag (sensible à la case)"
        },
        CATEGORIES: {
            ADD: "Ajouter",
            NEW: "Nouvelle catégorie",
            DELETE: "Supprimer",
            SAVE: "Sauvegarder les catégories",
            PLACEHOLDER: "Ecivez le nom d'une catégorie (sensible à la case)",
            ADD_SUB_CATEGORY: "Ajouter une sous-catégorie",
            ARE_YOU_SURE_DELETE_CATEGORY_TEXT: "Voulez-vous vraiment supprimer cette catégorie ?",
            ALREADY_EXISTS: "Cette catégorie existe déjà"
        }
    },
    SELECT_A_RANGE: "Sélectionnez une marque",
    ERROR_FORM: " erreurs trouvé(s) dans le formulaire.\nCorrigez les avant de soumettre le formulaire.",
    WARNING_FORM: " champ(s) à compléter pour valider la demande.",
    COMPARE_VERSION: "Version",
    COMPARE_RELEC: "Relecture",
    COMPARE_RESET: "Réinitialiser la comparaison",
    INTERN_REVISIONS: "Révisions internes",
    CLIENT_REVISIONS: "Révisions client",
    INTERN_REVISIONS_INFO: "Interne",
    EXTERN_REVISIONS_INFO: "Externe",
    CLIENT_REVISIONS_INFO: "Révision",
    VERSION_REVISIONS_INFO: "Versions",
    NOT_AVAILABLE_YET: "Fonctionnalité à venir",
    MAIN_APPROVER: "Approbateur principal",
    INFO_APPROVER: "Informatif",
    OBSERVER_APPROVER: "Observateur",
    GROUP_APPROVER: "Groupe",
    GROUP_MEMBER: "Membre du groupe",
    SELECT_APPROBATION_TYPE: "Sélectionner le type d'approbation du groupe",
    MEMBER_ALREADY_ADDED: "le(s) membre(s) : ${ name } ont déjà été ajoutés.",
    ONE_FOR_ALL: "Décision commune",
    INDIVIDUAL: "Décision individuelle",
    FILE: "Fichier",
    UPLOAD_FILE: "Charger un fichier",
    UPLOAD_BRIEF: "Charger un brief",
    OPTIONAL: "Optionnel",
    MEMBERS_STATUS: {
        NULL: "Pas d'approbation",
        PAUSED: "En pause",
        PENDING: "Pas d'approbation",
        ACCEPT: "Accepté",
        REJECT: "Rejeté",
        INPROGRESS: "En cours",
        READONLY: "Lecture seule",
        READONLYPROOFSCOPE: "Consultation"
    },
    REQUEST_STATUS_UPDATE: "Mettre a jour le status de la requête",
    REQUEST_STATUS_UPDATE_CONFIRMATION: "Voulez-vous vraiment mettre à jour le status de la requête ?",
    REQUEST_STATUS_UPDATED: "Le status de la requête a été mis à jour.",
    ED: {
        SELECT_REQUEST_TYPE: "Sélectionnez votre type de demande",
        SELECT_REQUEST_TYPE_PLACEHOLDER: "Quel type de demande souhaitez-vous réaliser ?",
        EPSON: {
            PRINT_EPSON: "Impression Epson",
            QUANTITY: "Quantité d'Epson",
            URL_SOURCE: "Url du fichier",
            URL_TARGET: "Destination Epson",
            URL_SOURCE_PLACEHOLDER: "Url du fichier à imprimer",
            URL_TARGET_PLACEHOLDER: "Url du Hot Folder",
            ARE_YOU_SURE_PRINTING: "Le projet sera envoyé en impression sur ",
            ACTION: {
                PRINT: "Imprimer",
                PRINT_PATHS: "Chemins d'impression"
            },
            AVAILABLE_PR: {
                EXE: "EXE",
                REPRO: "REPRO",
                EZD_EXE: "EXE",
                CREA: "CREA",
                HD: "HD"
            }
        },
        ALL: "Tous",
        EDIT: "Editer la requête.",
        ALREADY_SENT: "Demande déjà envoyée.",
        ARCHIVE: "Indiquer l'archive concernée :",
        PROJECT_ARCHIVED: "Indiquer le projet concerné :",
        GENERATE_ARCHIVE: "Générer l'archive",
        REGENERATE_ARCHIVE: "Régénérer l'archive",
        AVAILABILITY_DATE: "Dispo. juqu'au ",
        PLEASE_CHOOSE_TEXTS_TYPE: "Veuillez choisir comment vous souhaitez nous indiquer les nouveaux textes :",
        ZIP_TXT_DOC: "Veuillez compiler l’ensemble de votre demande/fiche texte dans un seul document (PPT/Word/Excel)",
        ZIP_PLAN_DOC: "Veuillez compiler l’ensemble de votre demande dans un seul document (PDF)",
        INSTRUCTIONS: "Vous pouvez indiquer ici les instructions pour les textes",
        ARE_YOU_SURE_CLOSE: "Le demande sera archivée.",
        CLOSE: "Clôturer la demande",
        DASHBOARD: "Dashboard",
        MEMBERS_INDICATE: "Indiquez les membres qui reliront les référénces",
        ARE_YOU_SURE_DELETE: "Voulez-vous vraiment clore cette demande ?",
        ARE_YOU_SURE_VALIDATE: "Voulez-vous vraiment valider et envoyer cette demande ?",
        REQUEST_DELETED: "La demande a été supprimée.",
        REQUEST_CREATE_ARCHIVE: "Créer une archive",
        REQUEST_CREATE_ARCHIVE_CONFIRMATION: {
            "HERO-IMAGE":
                "Une archive sera créée et envoyée à partir des éléments présents dans le sous-dossier '3. HD'.\n Vérifiez bien ces éléments avant de continuer.",
            "VISUALS-ISOLATION":
                "Une archive sera créée et envoyée à partir des éléments présents dans le sous-dossier '3. HD'.\n Vérifiez bien ces éléments avant de continuer.",
            PACKSHOT:
                "Une archive sera créée et envoyée à partir des éléments présents dans le sous-dossier '3. HD'.\n Vérifiez bien ces éléments avant de continuer.",
            "FILE-REDELIVERY":
                "Une archive sera créée et envoyée à partir des éléments présents dans le sous-dossier 'z_Elements_divers/_LIVRAISON_[EXE ou REPRO]'.\n Vérifiez bien ces éléments avant de continuer."
        },
        SHOOTING: "Prises de vue",
        FINISH: {
            FINISH: "Finalisation",
            COMM: "Vous pouvez indiquer ici des compléments d’information si vous le souhaitez",
            TXT: "J’ai compris que j’engage ma responsabilité quand aux éléments qui seront validés de ma part avant livraison des fichiers. \n Diadem réalise les corrections demandées, leurs validations et le process de relecture reposent entièrement sur le client.",
            CONTACT_TXT:
                "J’ai compris que cette prestation sera intégralement gérée via la plateforme Easy Diadem, sans relation directe avec vos contacts habituels chez Diadem. Pour toute demande de prestation jugée trop complexe, ou en cas de prise de contact autrement que par la plateforme Easy Diadem, Diadem se réserve le droit de réaliser un devis additionnel en fonction de la complexité du travail demandé"
        },
        FILES: {
            UPLOAD_SUCCESS: "Les fichiers ont bien été chargés.",
            UPLOAD_FAILED: "Une erreur est survenue lors du chargement des fichiers."
        },
        REQUEST: {
            ERROR: "Une erreur est survenue lors de la création de la requête.",
            NAME: "Requête EZD",
            CREATED: "Votre requête a bien été créée.",
            VALIDATED: "Votre requête a bien été validée et envoyée.",
            SAVED: "Votre formulaire a été enregistré.",
            NAME_REQUIRED: "Le nom de la requête est obligatoire.",
            NOT_EDITABLE: "Cette requête ne peut pas être modifiée.",
            NOT_VALID_FOR_SUBMISSION: "Impossible d'enregistrer cette requête en attente tant que les champs obligatoires signalés ne sont pas renseignés."
        },
        STATUS: {
            INIT: "En cours de création",
            PENDING: "En attente de traitement",
            PROJECT_LINKED: "Pris en charge",
            WAITING_PRODUCTION: "En attente de production",
            PRODUCTION: "En cours de production",
            RELECTURE_IN_PROGRESS: "Relecture en cours",
            VALIDATED: "Validé",
            UNVALIDATED: "Non validé",
            DELIVERING: "En cours de livraison",
            DELIVERED: "Livré",
            CLOSED: "Requête clôturée."
        },
        VISUAL_ISOLATION_DESCRIPTION: "Merci de lister les éléments à isoler (ou charger un brief ci-dessous)",
        ACTION: {
            CLOSE: "Clôturer",
            DELIVERY: "Livrer"
        },
        BRIEFING: {
            REQUEST_UNCOMPLETE: "Requête incomplète",
            REQUEST_UNCOMPLETE_TEXT:
                "Votre requête va être sauvegardée mais elle ne sera traitée que lorsque les éléments obligatoires seront fournis.\n Veuillez vérifier les éléments suivants :",
            MISSING_SUBJECT: "Brief Client - Sujet manquant",
            MISSING_OTHER_SUBJECT: "Brief Client - Veuillez préciser le Travail à effectuer",
            MISSING_BRIEF_FILE: "Brief Client - Fichier brief manquant",
            MISSING_TECHNICAL_NEW_REF_FILE: "Plan technique - Fichier plan technique manquant en cas de nouvelle référence",
            MISSING_TECHNICAL_NO_INFO: "Plan technique - Veuillez indiquer si vous avez des informations sur le plan technique",
            MISSING_TECHNICAL_UPDATE_REF_FILE: "Plan technique - Fichier plan technique manquant en cas de mise à jour de référence",
            MISSING_TEXT_SHEET_ARCHIVE: "Fiche texte - Nom ou numéro de l'archive manquante",
            MISSING_TEXT_SHEET_FILE: "Fiche texte - Fichier fiche texte manquant",

            TITLE: "Fiche de Brief",
            TYPE_DATAS: "Saisissez vos données",
            TYPE_DATE: "Sélectionnez une date avec le calendrier",
            MANDATORY: "Obligatoire",
            REQUIRED_SECTION: "Cette section est obligatoire pour démarrer le traitement de la requête",
            REQUIRED_FIELD: "Champ obligatoire",
            OPTIONAL_FIELD: "Champ facultatif",
            CUSTOMER_BRIEF: "Brief Client",
            COLOUR: "Couleur",
            CREA_FILES: "Fichiers Créa",
            IMAGES_TO_RETOUCH: "Images à retoucher",
            ARCHIVE_EXISTING_REFERENCE: "Archive référence existante",
            NUM_JOB_QUESTION: "Quel est le numéro de job ?",
            NUM_JOB_LABEL: "Numéro de job",
            NUM_JOB_LABEL_PLACEHOLDER: "Entrez le numéro de job",
            TECHNICAL_PLAN: "Plan technique",
            TECHNICAL_PLAN_CONTENT: {
                TYPE: "Type de demande",
                NEW_REF_SHORT: "Nouvelle(s) référence(s)",
                UPDATE_REF_SHORT: "Mise à jour d'une (ou plusieurs) référence(s)",
                NO_INFO_SHORT: "Pas encore d'information",
                NEW_REF_TITLE: "Veuillez déposer le/les fichier(s) du plan technique ici",
                NEW_REF_SUBTITLE: "Précision : format PDF (ou .ai, .dxf)",
                NEW_REF_TITLE_2: "Ou nous indiquer si d'autres références ont le même plan",
                UPDATE_REF_TITLE: "Le/les plan(s) a-t-il/ont-ils évolué(s) par rapport à l'archive ?",
                OPTION_YES: "Oui",
                OPTION_NO: "Non",
                UPDATE_REF_SUBTITLE: "Veuillez déposer le/les nouveau(x) fichier(s) du plan technique ici",
                NO_INFO_TITLE: "Pas encore d'information à ce sujet"
            },
            TEXT_SHEET: "Fiche texte",
            TEXT_SHEET_CONTENT: {
                TITLE: "Où récupérer les textes ?",
                OPTION_ARCHIVE: "Récupérer les textes sur l'archive (Veuillez remplir le champ ci-dessous)",
                OPTION_CREA: "Conserver les textes sur la Créa",
                OPTION_FILE: "Dépôt d'une fiche texte",
                OPTION_ONLINE: "Création d'une fiche texte en ligne",
                ARCHIVE_TITLE: "Pour une archive, veuillez indiquer la/les archive(s) concernée(s)",
                ARCHIVE_LABEL: "Nom ou numéro des archives",
                FILE_TITLE: "Pour un dépôt, veuillez déposer ici la/les fiche(s) texte(s)",
                FILE_SUBTITLE: "Précision : Format PDF/Word/Excel/PowerPoint"
            },
            PRINTING_METHOD: "Méthode d'impression & cahier des charges imprimeur",
            PRINTING_METHOD_SHORT: "Méthode d'impression",
            PRINTING_METHOD_CONTENT: {
                PRINTING_METHOD_LABEL: "Si vous connaissez la/les méthode(s) d'impression, veuillez l'indiquer",
                PRINTING_METHOD_SHORT: "Méthode(s) d'impression",
                PRINTER_NAME_LABEL: "Si vous connaissez le nom de l'imprimeur, veuillez l'indiquer",
                PRINTER_NAME_SHORT: "Nom de l'imprimeur",
                SPECIFICATIONS_LABEL: "Si vous disposez du cahier des charges de l'imprimeur, veuillez le déposer ici"
            },
            COLORING: "Mise en couleur",
            COLORING_CONTENT: {
                TYPE: "Quelle est la mise en couleur de votre/vos référence(s) ?",
                NEW_REF_SHORT: "Nouvelle(s) référence(s)",
                UPDATE_REF_SHORT: "Mise à jour d'une (ou plusieurs) référence(s)",
                NO_INFO_SHORT: "Pas encore d'information",
                NEW_REF_TITLE:
                    "Veuillez nous indiquer la mise en couleur déterminée (ou le nombre maximum de couleurs autorisées pour l'impression)",
                UPDATE_REF_TITLE: "La/les mise(s) en couleurs a-t-elle/ont-elles évoluée(s) par rapport à l'archive ?",
                OPTION_YES: "Oui",
                OPTION_NO: "Non",
                UPDATE_REF_SUBTITLE:
                    "Veuillez nous indiquer la mise en couleur déterminée (ou le nombre maximum de couleurs autorisées pour l'impression)",
                NO_INFO_TITLE: "Pas encore d'information à ce sujet"
            },
            BRAND_CHART: "Charte de marque",
            BRAND_CHART_TITLE: "Si vous disposez d'une charte de marque, veuillez la déposer ici ",
            BRAND_CHART_SUBTITLE: "Précision : Ce n'est pas nécessaire s'il n'y en a pas ou si Diadem en dispose déjà d'une",
            DEADLINE: "Délai",
            DEADLINE_TITLE: "Veuillez indiquer le délai de livraison des fichiers d'Exécution",
            VALIDATION_CYCLE: "Cycle de validation",
            VALIDATION_CYCLE_TITLE:
                "Si vous utilisez notre plateforme de relecture Liveco, veuillez nous lister les personnes à inclure dans le cycle de validation",
            CUSTOMER_CONTACT: "Contact client",
            CUSTOMER_CONTACT_TITLE: "Veuillez nous indiquer qui est le contact chez le client",
            SUBJECT_TITLE: "Brief Client",
            SUBJECT_LABEL: "Quel est l'objet du travail demandé ?",
            OTHER_TITLE: "Veuillez préciser :",
            OTHER_LABEL: "Travail à effectuer",
            OTHER_SUBJECT_PLACEHOLDER: "Décrivez le travail",
            BRIEF_TITLE: "Préparation de brief",
            BRIEF_LABEL: "Si vous avez préparé un brief, veuillez le déposer ici",
            COMMENT: "Informations supplémentaires si besoin",
            COMMENT_PLACEHOLDER: "Ajoutez un commentaire",
            REMARK: "Remarques",
            CREA_FILES_TITLE:
                "S'il s'agit d'une ou plusieurs nouvelles références, veuillez déposer ici les fichiers sources créatifs validés",
            CREA_FILES_SUBTITLE: "Précision : Assemblage des fichiers sources Illustrator non vectorisés avec textes vivants",
            IMAGES_TO_RETOUCH_TITLE:
                "S'il y a des nouvelles images à retoucher, veuillez déposer ici les fichiers sources (Les achats d’art ou les shoots)",
            IMAGES_TO_RETOUCH_SUBTITLE: "Précision : Images Photoshop sources non aplaties, traitées en CMJN.",
            ARCHIVE_REF_TITLE: "Si vous disposez d'archives pour votre (ou vos) référence(s), veuillez déposer les fichiers existants ici",
            ARCHIVE_REF_SUBTITLE:
                "Précision : De préférence les fichiers sources d'Exécution : Illustrator non vectorisé avec textes vivants, PDF, et fichiers Photoshop pour les images. Au minimum un PDF.",
            SUBJECTS: {
                UPDATE: "Mise à jour d'une référence existante",
                UPDATE_MULTIPLE: "Mise à jour de plusieurs références existantes",
                NEW_REF: "Exécution d'une nouvelle référence",
                NEW_MULTIPLE: "Exécution de plusieurs nouvelles références",
                LOGO_EXE: "Exécution de logo",
                OTHER: "Autres",
                EXE_ONLY: "Exécution seule",
                EXE_AND_RETOUCH: "Exécution et Retouche d'image",
                RETOUCH_ONLY: "Retouche d'image seule",
                FILE_PREPARATION: "Préparation de fichiers pour maquettes",
                ISOLATION: "Isolations (pictos, logos, visuels...)"
            },
            NAME_QUESTION: "Quel est le nom du projet ou de la référence à traiter?"
        },
        WHAT_CAN_WE_DO: "Que pouvons-nous faire pour vous aujourd'hui ?",
        TASKS: {
            PACKSHOT: "Réalisation d’un packshot",
            HERO_IMAGE: "Réalisation d’une Hero image",
            "HERO-IMAGE": "Réalisation d’une Hero image",
            "NEW-ACCOUNT": "Nouveau compte",
            BRIEFING: "Fiche de Brief Client",
            NEW_ACCOUNT: "Nouveau compte",
            NEW_EPSON: "Nouvelle Epson",
            "NEW-EPSON": "Nouvelle Epson",
            VISUALS_ISOLATION: "Isolation de visuel",
            "VISUALS-ISOLATION": "Isolation de visuel",
            FILE_REDELIVERY: "Relivraison de fichiers",
            "FILE-REDELIVERY": "Relivraison de fichiers",
            TEXT_CORRECTION: "Correction de texte simple",
            "TEXT-CORRECTION": "Correction de texte simple",
            "PLAN-CORRECTION": "Correction de plan (sans correction de textes)",
            PLAN_CORRECTION: "Correction de plan (sans correction de textes)",
            "TEXT-PLAN-CORRECTION": "Correction de texte et plan",
            TEXT_PLAN_CORRECTION: "Correction de texte et plan",
            PDF_REPOSITORY: "Dépôt de PDF",
            "PDF-REPOSITORY": "Dépôt de PDF",
            "BAT-REPOSITORY": "Dépôt de BAT",
            BAT_REPOSITORY: "Dépôt de BAT",
            NONE: "Aucune"
        },
        "PDF-REPOSITORY-TITLE": "Dépôt de PDF",
        "BAT-REPOSITORY-TITLE": "Dépôt de BAT",
        SELECTION_SOURCE_PROJECT_READONLY: "Précision : ....",
        "PDF-REPOSITORY": "Dépôt de PDF",
        "LINK-PROJECT": "Relier à un projet existant",
        WHAT_DO_YOU_WANT: "Merci de nous préciser votre demande *",
        WHICH_PROJECT: "Sur quel projet voulez-vous isoler un visuel ?",
        SEARCH_PROJECT: "Rechercher un projet...",
        SEND_DEMAND: "Envoyer la demande",
        SAVE_DEMAND: "Sauvegarder les modifications",
        SAVE_WITHOUT_RELECTURE: "Sauvegarder sans nouvelle relecture",
        LINK_PROJECT: "Relier la demande",
        LINK_USER: "Créer compte",
        PLAN_UPLOAD: "Dépôt de plan",
        OTHER_TYPE_REQUEST: "Autre type de demande",
        NEW_REQUEST: "Création d'une nouvelle demande",
        EDIT_REQUEST: "Edition de la demande",
        REQUEST_TYPE: "Type de requête",
        YOUR_DEMAND: "Votre demande",
        REQUEST_CREATE_PLACEHOLDER: "Séléctionnez un type de demande pour afficher puis remplir les champs correspondants",
        HAS_BEEN_TAKEN_INTO_CONSIDERATION: "a bien été prise en compte",
        AN_ERROR_OCCURED: "Une erreur est survenue",
        CLICK_HERE_TO_DROP_PDF: "Cliquez ici pour déposer votre PDF",
        CLICK_HERE_TO_DROP_FILE: "Veuillez cliquer ou déposer votre fichier ici",
        CLICK_HERE_TO_DROP_FILES: "Veuillez cliquer ou déposer vos fichiers ici",
        MAX: "Maximum",
        FILES_MIN: "fichiers",
        ALLOWED_FORMATS: "formats autorisés",
        FILE_DOWNLOAD: "Fichier téléchargé",
        PROJECT_LABEL: "Nommez votre projet",
        PROJECT_LABEL_PLACEHOLDER: "Nom du projet",
        MEMBERS: "Membres",
        MEMBER: "Membre",
        ADD_MEMBER: "Ajouter un membre",
        STEP: {
            QUESTION: "Les informations ci-dessous sont-elles toujours exactes ?",
            QUESTION_PLAN: "En dehors du plan, les informations ci-dessous sont-elles toujours exactes ?",
            MEMBERS_TXT: "Indiquer les contacts qui reliront la référénces après corrections",
            COMM: "Quels sont les changements à apporter ?",
            PROOFREADING: "Modifier/Créer fiche texte",
            INSTRUCTIONS: "Écrire instructions",
            UPLOAD: "Dépôt de fiche textes",
            TXT: "Veuillez choisir comment vous souhaitez nous indiquer les nouveaux textes :",
            PLAN: "Veuillez choisir comment vous souhaitez nous indiquer le nouveau plan :"
        },
        TYPES: {
            "HERO-IMAGE": "Héro Image",
            "VISUALS-ISOLATION": "Isolation de visuel",
            "PDF-REPOSITORY": "Dépôt de PDF",
            "BAT-REPOSITORY": "Dépôt de BAT",
            "TEXT-CORRECTION": "Correction de texte",
            "PLAN-CORRECTION": "Correction de plan",
            "TEXT-PLAN-CORRECTION": "Correction de texte et plan",
            "NEW-EPSON": "Nouvelle Epson",
            PACKSHOT: "Réalisation d’un packshot",
            "FILE-REDELIVERY": "Relivraison de fichiers",
            "NEW-ACCOUNT": "Nouveau compte",
            BRIEFING: "Fiche de Brief Client"
        },
        DOWNLOAD: "Télécharger les éléments",
        USERNAME_EXIST: "Ce nom est déjà utilisé. Veuillez en choisir un autre",
        EMAIL_EXIST: "Cet email est déjà utilisé. Veuillez en choisir un autre",
        STEPPER: {
            INIT: {
                TITLE: "Commande en attente d'information",
                DESC: "Veuillez saisir les élements manquants"
            },
            PENDING: {
                TITLE: "Commande prise en compte",
                DESC: "Requête easyDiadem reçue"
            },
            PROJECT_LINKED: {
                TITLE: "En cours de traitement",
                DESC: "Requête validée"
            },
            WAITING_PRODUCTION: {
                TITLE: "Attente de production",
                DESC: "Date à définir",
                DESC_DATE: "Prévu le %%DATE%%"
            },
            PRODUCTION: {
                TITLE: "En production",
                DESC: "Requête traitée"
            },
            RELECTURE_IN_PROGRESS: {
                TITLE: "En relecture client",
                DESC: ""
            },
            DELIVERING: {
                TITLE: "Préparation livraison",
                DESC: "Préparation des fichiers"
            },
            DELIVERED: {
                TITLE: "Livré",
                DESC: "Fichiers livrés"
            },
            CLOSED: {
                TITLE: "Traitement terminé",
                DESC: "Le projet a été mené a terme"
            }
        },
        REDELIVERY: {
            TXT: "Je comprends que les fichiers seront disponibles pendant une période de 30 jours à compter de ma demande."
        }
    },
    QUANTITY: "Quantité",
    ATTACHMENT: "Pièce jointe",
    ATTACHMENTS: "Pièce(s) jointe(s)",
    ATTACHMENTS_LIST: "Fichiers transmis pour la relecture",
    ATTACHMENTS_LIST_EMPTY: "Aucune pièce jointe pour cette relecture",
    ATTACHMENTS_LIST_EMPTY_INFO: "Vous pouvez ajouter des pièces jointes en cliquant sur le bouton 'Charger'",
    ATTACHMENTS_ADD: "Charger une pièce jointe",
    ATTACHMENTS_LEGEND: "Vous pouvez ajouter un fichier complémentaire ici si nécessaire.",
    OLD_REF: "Ancienne référence",
    NEW_PROJECT: "Nouveau projet créé",
    PROOFREADING: "Relecture",
    NEW_PROOFREADING: "Nouvelle relecture",
    ADD_FIELD: "Champ personnalisé",
    ADRESS: "Adresse",
    ALERT: {
        MODIF_DOC: "Attention, vous ne pourrez plus revenir sur le document"
    },
    NO_PROOFREADING: "Pas de relecture",
    APPROVAL: {
        APPROVED: "Votre document a été approuvé",
        REJECT: "Votre document a été rejeté",
        TITLE: "Approbation"
    },
    APPROVE: {
        REJECT: "Rejeter",
        VALID: "Approuver"
    },
    APPROVERS: {
        DIALOG: {
            TEXT: "Attention, vous ne pourrez plus revenir sur le document",
            TITLE: "Envoyer vos commentaires"
        }
    },
    BACK: "Dos + côtés",
    CANCEL: "Annuler",
    CITY: "Ville",
    CODES: {
        ADRESS: "Adresse",
        CODE: "Code",
        CODES: "Gencod / QR code",
        COLOR: "Couleur",
        CORRECT: "Correction",
        DATAMATRIX: "Datamatrix",
        NAMEMACHINE: "Nom du cahier des charges",
        ECOLOR: "Couleur",
        GENCOD: "Gencod",
        GENCODTAILLE: "Taille mini",
        QRCODE: "QR CODE",
        RLB: "RLB",
        SENS: "Sens",
        TAILLE: "Modules / Tailles mini",
        TYPE: "Type",
        NAMESUPPORT: "Nom du support"
    },
    COLORS: {
        MANAGE: "Gérer les couleurs",
        COLOR: "Couleur",
        COLORS: "Mise en couleurs",
        COMM: "Spécificités imprimeur",
        COLORMAX: "Nombre de couleur maximum",
        MECREEL: "Nombre de couleur utilisées",
        PRINTCOLOR1: "Couleur 1",
        PRINTCOLOR10: "Couleur 10",
        PRINTCOLOR2: "Couleur 2",
        PRINTCOLOR3: "Couleur 3",
        PRINTCOLOR4: "Couleur 4",
        PRINTCOLOR5: "Couleur 5",
        PRINTCOLOR6: "Couleur 6",
        PRINTCOLOR7: "Couleur 7",
        PRINTCOLOR8: "Couleur 8",
        PRINTCOLOR9: "Couleur 9",
        PRINTFINITION1: "Finition 1",
        PRINTFINITION10: "Finition 10",
        PRINTFINITION2: "Finition 2",
        PRINTFINITION3: "Finition 3",
        PRINTFINITION4: "Finition 4",
        PRINTFINITION5: "Finition 5",
        PRINTFINITION6: "Finition 6",
        PRINTFINITION7: "Finition 7",
        PRINTFINITION8: "Finition 8",
        PRINTFINITION9: "Finition 9",
        PRINTFINITIONS: "Finitions",
        PRINTSEQ: "Séquence impression",
        REFS: "Références",
        SAMECOLORS: "Couleur communes",
        VALIDATORS: {
            NUMERIC: "Veuillez saisir un nombre"
        }
    },
    COLORBOOKS: {
        COLORBOOKS: "Nuancier (couleurs)",
        FINISHCOLORS: "Nuancier (finitions)",
        VALIDATORS: {
            COLORS: "Veuillez saisir un nom de couleur",
            CATEGORIES: "Veuillez sélectionner une catégorie"
        },
        CATEGORIES: "Catégories de couleur",
        COLORS: "Couleurs à ajouter",
        PLACEHOLDER: "PANTONE 100 C, PANTONE 101 C, PANTONE 102 C, PANTONE 103 C, PANTONE 104 C, PANTONE 105 C, PANTONE 106 C...",
        UPDATE: "La palette de couleurs a été mis à jour",
        CREATE: "La palette de couleurs a été créée",
        DIALOG: {
            EXIST: "Les couleurs suivantes existent déjà dans cette catégorie (elles ne seront pas créées)"
        }
    },
    COMM: "Commentaires",
    COMM_SUBMIT: "Commentaires sauvegardés",
    CONSTRAINTS: "Contraintes techniques",
    CONTACT: "Contact",
    CREATE: "Créer",
    CREATE_CHILD: "+ projet enfant",
    CREATE_DIALOG: {
        TEXT: "Envoyer au client ?",
        TITLE: "Fiche texte"
    },
    CREATE_MASTER: "+ projet parent",
    CUSTOM_FIELDS: "Champs personnalisés",
    CUSTOMER: {
        SEARCH: "Rechercher un client..."
    },
    MEMBERS: "Membres",
    TEAM_CREATIF_MEMBERS_SHORT: "Membres TC",
    CONTROL: "Contrôle",
    DASHBOARD: {
        BRIEF: "Fiche de brief",
        SPLITVIEW: "Relecture client",
        SPLITVIEW_INTERN: "Relecture interne",
        FOLDER: "Ouvrir le dossier",
        PACKZ: "Ouvrir avec PacKZ",
        UPDATE_JOB: "Editer le projet",
        HISTORY: "Historique des relectures",
        CONTROL_INTERN: "Relecture interne",
        COMPARE: "Comparer des versions",
        PREVIEW: "Prévisualiser",
        SET_READY: "Le job est prêt",
        REFRESH: "Rafraîchir la vue",
        FULLSCREEN: "Plein écran",
        STATS: "KPI"
    },
    STATUS: "Statut",
    DESCRIPTION: "DESCRIPTION",
    DIALOG: {
        APPROVE: {
            REJECT: "Rejeter",
            TEXT: "",
            TITLE: "Approbation du document",
            VALID: "Approuver"
        },
        ASSESSMENT: {
            TEXT: "",
            TITLE: "Approbation du document",
            VALID: "Approuver",
            APPROBATION: "Approbation",
            REJECT: "Rejet",
            APPROBATION_TXT: "Confirmez-vous l’approbation du document?",
            REJECT_TXT: "Confirmez-vous le rejet du document?",
            INTERNAL_APPROBATION_TXT: "Avez-vous bien ajouté vos commentaires dans Proofscope avant d’approuver ?",
            INTERNAL_REJECT_TXT: "Avez-vous bien ajouté vos commentaires dans Proofscope avant de rejeter ?"
        },
        PAUSE: {
            TITLE: "Pause",
            TEXT: "Mettre en pause la relecture en cours"
        },
        RESTART: {
            TITLE: "Redémarrer le cycle",
            TEXT: "Redémarrer la relecture en cours"
        }
    },
    DOCUMENT_READONLY: "Lecture seule",
    DOCUMENT_READONLY_PROOFSCOPE: "Consultation",
    READONLYPROOFSCOPE: "Consultation",
    READONLY: "Lecture seule",
    PENDING: "En attente",
    DOCUMENT_PENDING: "En attente",
    DOCUMENT_APPROVE: "Document approuvé",
    ACCEPT: "Document approuvé",
    DOCUMENT_REJECT: "Document rejeté",
    REJECT: "Document rejeté",
    "INPROGRESS-R": "En cours de traitement",
    INPROGRESS: "En cours de traitement",
    EMAIL: "Email",
    ERROR_CLIENTONLY_ATTRIBUTES_NAME: "Un Client ne peut pas etre membre de DIADEM",
    ERROR_MISSING_ATTRIBUTES_NAME: "Veuillez saisir des attributs",
    ERROR_MISSING_MARQUE_FOR_CUSOMER: "Veuillez saisir une marque pour un Client",
    ERROR: {
        NODATA: "Impossible de récupérer les données",
        NOREVISIONS: "Pas de relecture pour ce projet",
        NOSUBMIT: "Impossible de soumettre les données",
        NO_EDIT_MASTER: "Impossible de modifier les données d'un projet parent",
        ONLYCPPCAN: "Seuls les CPP peuvent accéder à cette page",
        ONLYOPERATORADMINCAN: "Seuls les opérateurs et les administrateurs peuvent accéder à cette page",
        ONLYDIADEMCAN: "Seuls les membres de diadem peuvent acceder a cette page",
        ONLY_INTERNAL_SPLITVIEW_ALLOWED: "Vous devez utiliser la vue interne pour cette relecture",
        MUST_BE_IN_LIST: "L'entrée selectionnée doit être dans la liste",
        L2PUB_PROJECTS: "Erreur lors de la récupération des projets L2PUB"
    },
    NEW_PLAN: "Nouveau plan",
    FACING: "Facing",
    FIELD_NAME: "Nom du champ",
    FILETMINNEG: "Filet minimum négatif",
    FILETMINPOS: "Filet minimum positif",
    GO_TO_HOME: "Menu",
    ERRORS: {
        QUANTITY: "Veuillez saisir une quantité valide 1 - 5",
        REQUIRED_EMAIL: "Veuillez saisir une adresse email valide",
        TEL: "Veuillez saisir un numéro de téléphone valide",
        CONTACT: "Veuillez indiquer une adresse"
    },
    HOME: {
        SPLIT_VIEW: "Relecture",
        SPLIT_VIEW_INTERN: "Relecture interne",
        ARCHIVE: "Archiver",
        ARCHIVED: "Archivé",
        COLORBOOKS: "Nuancier",
        DISARCHIVE: "Désarchiver",
        OPEN_FOLDER: "Ouvrir le dossier",
        BRIEF: "Fiche de brief",
        CREATE: "Fiche textes",
        CREATE_CHILD: "Projet enfant",
        CREATE_MASTER: "Projet parent",
        CREATE_PRINTER: "Créer un imprimeur",
        CREATE_PROJECT: "Créer un projet",
        CREATE_USER: "Ajouter un utilisateur",
        EDIT_PROJECT: "Éditer un projet",
        FORM: "Fiche textes",
        KIOSK: "Cloudflow",
        MENU: "Menu",
        PRINTER: "Imprimeur",
        HOME: "Accueil",
        PROJECT: "Projet",
        SPLITVIEW: "Relecture client",
        TABLE_PROJECT: "Projets",
        TABLE_PRINTER: "Imprimeurs",
        TABLE_USER: "Utilisateurs",
        UPDATE: "Éditer une fiche textes",
        USERS: "Utilisateurs",
        ACCOUNT: "Mon compte",
        ARCHIVING_IN_PROGRESS: "Archivage programmé",
        UNARCHIVING_IN_PROGRESS: "Désarchivage programmé"
    },
    INFO: "Informations générales",
    MINTXTNEG: "Texte minimum négatif",
    MINTXTPOS: "Texte minimum positif",
    NAME: "Nom",
    NOPERMISSION: {
        TEXTAPPRO: "Textes envoyés aux approbateurs",
        TEXTOK: "Textes sont déjà OK",
        TITLE: "Pas de permission",
        TITLE_TEXTOK: "Pas de permission"
    },
    NOREF: "Pas de référence disponible",
    NORESULT: "Aucun résultat",
    NUTRITABLE: {
        AR_PORTION: "% AR / portion",
        FOR_100: "100",
        FOR_100_UNIT: "g/ml",
        FOR_PORTION: "Une portion de",
        UNIT_G: "(g)",
        UNIT_KCAL: "(Kcal)",
        UNIT_KJ: "(kJ)",
        VALEUR_MOYENNES: "Valeurs moyennes pour :"
    },
    PATCH_NOTES: {
        LIVECO_UPDATE: "Mise à jour Liveco",
        TITLE: "Titre",
        COMMENT: "Commentaires",
        DATE: "Date",
        ARE_YOU_SURE_DELETE_PATCH_NOTES: "La note de mise à jour sera supprimée",
        DELETE_SUCCESS: "La note de mise à jour a été supprimée",
        NEW: "Créer une nouvelle note",
        NOTES: "Notes de mise à jour"
    },
    OK: "Ok",
    ORIENTATION: "Orientation",
    PAYS: "Pays",
    PC_EDIT_SUCESS: "Vos modifications ont été enregistrées",
    POSTALCODE: "Code postal",
    PREFILL_JOB_CHILD_REFERENCE: "Pré-remplir les champs du projet enfant",
    PREFILL_JOB_MASTER_REFERENCE: "Pré-remplir le projet maître",
    UPDATE_DATE: "Date de Maj",
    PAUSE: "Pause",
    PASSWORD: "Mot de passe",
    HOST: "Hôte",
    PORT: "Port",
    REMOTE_PATH: "Chemin distant",
    CONNECTION: "Connexion",
    PRINTER: {
        TABLE: {
            SPECS: "Spécifications",
            NO_SUPPORT: "aucun support",
            MORE_SPECS: "+ {{count}} autres : {{processes}}",
            LESS_SPECS: "Réduire",
            NO_WORD: "Aucun imprimeur ne contient « {{words}} ».",
            NO_IN_PROCESSES: "Des imprimeurs contiennent « {{text}} », mais aucun parmi {{processes}}.",
            CLEAR_PROCESSES: "Retirer le filtre procédés",
            CLEAR_SEARCH: "Effacer la recherche",
            UPDATED: "Mise à jour",
            LOAD_ERROR: "Impossible de charger les imprimeurs.",
            RETRY: "Réessayer",
            MATCH: {
                CONTACT: "Contact",
                POSTAL: "Code postal"
            },
            PAGINATOR: {
                PER_PAGE: "Par page",
                FIRST: "Première page",
                PREVIOUS: "Page précédente",
                NEXT: "Page suivante",
                LAST: "Dernière page",
                RANGE: "{{start}} – {{end}} sur {{length}}",
                RANGE_EMPTY: "0 sur 0"
            },
            RESULTS: "{{total}} imprimeurs",
            RESULTS_FILTERED: "{{shown}} sur {{total}} imprimeurs",
            REMOVE_FILTER: "Retirer le filtre",
            SEARCH: "Rechercher",
            SEARCH_PLACEHOLDER: "Nom, ville, procédé, cahier des charges, support, contact…",
            CLEAR_FILTERS: "Effacer les filtres",
            NO_RESULT: "Aucun imprimeur ne correspond à ces filtres.",
            EMPTY: "Aucun imprimeur pour le moment."
        },
        FORM: {
            COPY_FROM: "Copier un imprimeur existant",
            COPY_FROM_HINT: "Reprend les procédés, cahiers des charges, supports, adresse et contacts d'un imprimeur existant. Seul le nom reste à saisir.",
            GENERAL: "Informations générales",
            CONTACTS: "Contacts",
            NO_CONTACT: "Aucun contact.",
            PROCESSES: "Procédés",
            PROCESS: "Procédé",
            PROCESS_NAME: "Nom du procédé",
            PROCESS_HINT: "Choisissez dans la liste ou saisissez un autre procédé",
            MACHINE: "Cahier des charges",
            MACHINES: "Cahiers des charges",
            SUPPORT: "Support",
            SUPPORTS: "Supports",
            ADD_PROCESS: "Ajouter un procédé",
            ADD_MACHINE: "Ajouter un cahier des charges",
            ADD_SUPPORT: "Ajouter un support",
            DUPLICATE: "Dupliquer",
            UNNAMED: "(sans nom)",
            NO_PROCESS: "Aucun procédé : ajoutez-en un avec le bouton +.",
            NO_MACHINE: "Aucun cahier des charges pour ce procédé.",
            NO_SUPPORT: "Aucun support pour ce cahier des charges.",
            DELETE_PROCESS_CONFIRM: "Supprimer ce procédé, ses cahiers des charges et leurs supports ?",
            DELETE_MACHINE_CONFIRM: "Supprimer ce cahier des charges et ses supports ?",
            DELETE_SUPPORT_CONFIRM: "Supprimer ce support ?",
            PROOF_TYPE: "Type d'épreuvage",
            UPDATED_ON: "Mis à jour le",
            UNSAVED: "Modifications non enregistrées",
            INVALID: "Des champs obligatoires sont vides : ils sont signalés dans l'arborescence.",
            CREATED: "Imprimeur créé",
            SAVE_FAILED: "L'enregistrement a échoué, rien n'a été modifié."
        },
        PRINTING_METHOD: "Méthode d'impression",
        ADD_CONTACT: "Ajouter un contact",
        PREFILL_PRINTER: "Pré-remplir les champs imprimeur",
        SELECT_PRINTER: "Sélectionner un imprimeur",
        ARE_YOU_SURE_DELETE_PRINTER_TEXT: "L'imprimeur sera supprimé",
        NEW_PRINTER: "Nouvel imprimeur",
        CREATE_PRINTER: "Créer un nouvel imprimeur",
        COLLAGE: "Zone Collage",
        COLORDEBDEV: "Débord Couleur - développement",
        COLORDEBLAIZE: "Débord Couleur - laize",
        CREATE: "Créer imprimeur",
        EDIT_SUCESS: "Vos modifications ont été enregistrées",
        FILESEND: "Livraison Fichiers",
        MACHINE: "Machine",
        PRINT: "Impression",
        PRINTER: "Imprimeur",
        PRINTERS: "Imprimeurs",
        SENSIMPRESSION: "Sens d'impression",
        PROCESS: "Procédé d'impression",
        REPRO: {
            CONSTRAINTS: "Contraintes",
            CHROMIE: {
                CHROMIE: "Chromie",
                CIBLE: "Cible couleur fournie",
                ENCR: "Encrage maximum",
                PTMAX: "Point maxi",
                PTMIN: "Point mini",
                REPROPROFIL: "Profil",
                TRAM: "Trame",
                STEPREUVAGE: "Standard épreuvage"
            },
            EPREUVAGE: "Épreuvage",
            FILE1: "Fichiers à fournir",
            FILE2: "PSD",
            OPERATOR: "Infographiste REPRO",
            REPRO: "REPRO",
            RETRAIT: {
                BLANC: "Retrait Blanc",
                COULEUR: "Retrait Couleur",
                VERNIS: "Retrait Vernis"
            },
            TRAP: "Trapping",
            TRAP_RETRAIT: "Trapping et retrait"
        },
        SECUCOUPE: "Sécurité Coupe",
        SECURAIN: "Sécurité Raineur",
        SEND: "Livraison Fichiers",
        SPECIFICATION: "Emplacement cahier des charges",
        SPOT: "Lecture Spot ",
        SUPPORT: "Support"
    },
    FINISHBOOKS: {
        COLORS: "Veuillez saisir un nom de finition",
        PLACEHOLDER: "VERNIS, VERNIS MAT, VERNIS BRILLANT..."
    },
    HISTORY: "Historique",
    INTERN_HISTORY: {
        NONE: "Création",
        "CHECK-AUTO-CONTROL": "Auto-contrôle",
        READY: "Prêt",
        "CHECK-QUALITY": "Contrôle qualité",
        "CHECK-REPRO": "Contrôle repro",
        "CHECK-PROD": "Contrôle graphique",
        "PROD-INTERN-REJECTED": "Auto contrôle rejeté",
        "CPP-INTERN-REJECTED": "Contrôle CPP rejeté",
        "CHECK-CPP": "Contrôle CPP",
        "WAITING-AUTO-CONTROL": "Modifications (auto-contrôle)",
        "WAITING-CHECK-CPP": "Modifications (Ctrl CPP)",
        "INTERN-FINISHED": "Contrôle CPP validé",
        "INTERN-FINISHED-OPERATOR": "Contrôle Opé. validé",
        CONTROL_APPROVED: "Contrôle validé",
        CONTROL_REJECTED: "Contrôle non validé",
        WIP: "En production",
        "CONTROL-VALIDATED": "Contrôle validé",
        "CONTROL-FAILED": "Contrôle refusé",
        GENERATING: "Génération",
        "PR-CLIENT-INPROGRESS": "Envoyé au client"
    },
    EXTERN: {
        BAT: "BAT",
        "SEND-PR-CLIENT": "Vérification des textes par le client",
        "SEND-PR-CPP": "Vérification des textes par le chef de projet",
        "IN-PROGRESS": "En cours d'approbation",
        REJECTED: "Document rejeté par le chef de projet",
        APPROVED: "Document approuvé par le chef de projet",
        "FEEDBACK-INFO": "Document revu par les approbateurs info.",
        "FEEDBACK-CLIENT": "Document revu par l'approbateur document.",
        PAUSED: "Relecture mise en pause.",
        DELIVERED: "Livré",
        "POST-VALIDATION": "Post-Validation",
        INIT: "Attente lancement",
        "IN-PRODUCTION": "En production",
        RESTART: "Redémarrer",
        WAIT_YOUR_TURN: "Veuillez attendre votre tour pour procéder à l'approbation, l'approbation en est à l'etape : ",
        BTN: {
            "IN-PRODUCTION": "Envoyer en production",
            "SEND-PR-CLIENT": "Envoyer au client",
            "SEND-PR-CPP": "Envoyer au chef de projet",
            "IN-PROGRESS": "Envoyer en approbation",
            REJECTED: "Rejeter",
            APPROVED: "Approuver",
            "FEEDBACK-INFO": "Document revu par les approbateurs info.",
            "FEEDBACK-CLIENT": "Document revu par l'approbateur document.",
            PAUSED: "Pause",
            RESTART: "Redémarrer",
            DELIVERED: "Livraison",
            "POST-VALIDATION": "Post-Validation",
            INIT: "Attente lancement"
        },
        DASHBOARD: {
            BAT: "BAT",
            NULL: "Pas de relecture interne",
            "SEND-PR-CLIENT": "Relec. txt. - Client",
            "SEND-PR-CPP": "Relec. txt. - CPP",
            INIT: "Att. lancement",
            "IN-PROGRESS": "Att. approbation",
            REJECTED: "Rejeté",
            APPROVED: "Accepté",
            PAUSED: "En pause",
            RESTART: "Redémarrer",
            "FEEDBACK-INFO": "Appro. info",
            "FEEDBACK-CLIENT": "Cycle client fini",
            DELIVERED: "Livré",
            NO_PROOFREADING: "Aucune proofreading n'a été trouvé",
            "POST-VALIDATION": "Post-Validation",
            "IN-PRODUCTION": "En production"
        },
        DIALOG: {
            "IN-PRODUCTION": "Voulez-vous envoyer la relecture en production ?",
            "SEND-PR-CLIENT": "Envoyer la relecture au client ?",
            "SEND-PR-CPP": "Valider la relecture aupres du chef de projet",
            "IN-PROGRESS": "En cours d'approbation",
            REJECTED: "Voulez-vous rejeter le document ?",
            APPROVED: "Voulez-vous approver le document ?",
            "FEEDBACK-INFO": "Voulez-vous soumettre votre approbation ?",
            "FEEDBACK-CLIENT": "Voulez-vous soumettre votre approbation ?",
            PAUSED: "Mettre la relecture en pause ?",
            DELIVERED: "Voulez-vous livrer le job ?",
            "POST-VALIDATION": "Voulez-vous remettre le job en production ?",
            RESTART: "Voulez-vous redémarrer l'approbation ?",
            INIT: "Voulez-vous remettre le job en attente de lancement ?"
        }
    },
    INTERN: {
        SELECT_FLOW: {
            TITLE: "Selection du Flux",
            DESC: "Veuillez selectionner le flux de travail"
        },
        WARN_PROD: {
            TITLE: "Avertissement !",
            RELECTURE: "Vous êtes en relecture : ",
            DESC: "Réalisez votre pack et remplissez les informations dans l'onglet cartouche de votre job dans Liveco 4.0"
        },
        TODO: {
            EXE: "EXE",
            REPRO: "REPRO",
            HD: "HD",
            CREA: "CREA",
            EZD_EXE: "EZD - EXE",
            INFO_CARTOUCHE: "Infos Cartouche",
            REPRO_FILES: "Fichier REPRO",
            EXE_FILES: "Fichier Natif",
            IMAGE: "Images",
            PSD: "PSD",
            VECT_PDF: "PDF Vectoriel",
            PDF_BD: "PDF BD",
            VECT_ILLUSTRATOR: "Illustrator Vectoriel",
            DAM_DELIVERY: "Livraison DAM",
            NOT_VECT_ILLUSTRATOR: "Illustrator Non Vectoriel",
            NOT_VECT_PDF: "PDF Non Vectoriel",
            FONTS: "Assemblage des polices + FontDisclaimer",
            PREPA_3D: "Préparation 3D",
            DELIVERY_TEMPLATE: "Template de livraison",
            FTP_DEPOSIT: "Dépôt FTP",
            PACKZ: "PACKZ",
            AI: "AI",
            ARTPRO: "Artpro",
            ARTPRO_PLUS: "Artpro +",
            PDF_HD: "PDF HD",
            PSD_PHOTOGRAVURE: "PSD Photogravure",
            PNG_BD: "PNG BD",
            PNG_HD: "PNG HD",
            JPG_BD: "JPG BD",
            JPG_HD: "JPG HD",
            FILE: "Fichiers à fournir",
            JPG_PNG_FACING_HD: "JPG / PNG FACING HD"
        },
        WARN_DELIVERY: {
            TITLE: "Controle avant livraison !",
            RELECTURE: "Vous êtes en relecture : ",
            DESC: "Contrôlez la présence de tous les fichiers nécessaires à la livraison avant Zip. Faire un assemblage via Illustrator si nécessaire à cette étape."
        },
        UNABLE_TO_SUBMIT: "Impossible de soumettre la demande",
        UNABLE_TO_SUBMIT_TEXT:
            "S'il s'agit de la relecture EXE, vérifiez que vous avez bien créé la fiche texte, et que celle-ci a également bien été envoyée.",
        UPDATE_DOC: "Auto-contrôle",
        NONE: "Brief en cours",
        READY: "Prêt",
        "CHECK-AUTO-CONTROL": "Auto-contrôle",
        "CHECK-QUALITY": "Contrôle qualité",
        "CHECK-REPRO": "Contrôle REPRO",
        "CHECK-PROD": "Contrôle graphique",
        "CHECK-CPP": "Contrôle CPP",
        GENERATING: "Génération en cours",
        "PROD-INTERN-REJECTED": "Auto contrôle rejeté",
        "CPP-INTERN-REJECTED": "Contrôle CPP rejeté",
        WIP: "En production",
        "CONTROL-VALIDATED": "Contrôle validé",
        "CONTROL-FAILED": "Contrôle refusé",
        CONTROL_APPROVED: "Contrôle validé",
        CONTROL_REJECTED: "Contrôle non validé",
        CONTROL_PENDING: "En attente de proofscope",
        "WAITING-AUTO-CONTROL": "Document en attente de modifications (auto-contrôle)",
        "WAITING-CHECK-CPP": "Document en attente de modifications (Ctrl CPP)",
        "INTERN-FINISHED": "Contrôle CPP validé",
        "INTERN-FINISHED-OPERATOR": "Contrôle Opé. validé",
        "TEAM-CREATIF-INPROGRESS": "Approbation TC en cours",
        "TEAM-CREATIF-FEEDBACK-INFO": "Avis TC reçus",
        "TEAM-CREATIF-FEEDBACK-CLIENT": "Décision TC reçue",
        "TEAM-CREATIF-APPROVED": "TC validé",
        "TEAM-CREATIF-REJECTED": "TC refusé",
        "INTERNAL-MEMBERS-INPROGRESS": "Approbation TC en cours",
        "INTERNAL-MEMBERS-FEEDBACK-INFO": "Avis TC reçus",
        "INTERNAL-MEMBERS-FEEDBACK-CLIENT": "Décision TC reçue",
        "INTERNAL-MEMBERS-APPROVED": "TC validé",
        "INTERNAL-MEMBERS-REJECTED": "TC refusé",
        "INTERN-FINISHED-INTERNAL-MEMBERS": "Approbation TC validé",
        PAUSED: "Approbation TC en pause",
        "RE-DELIVER": "Relivraison",
        PR_CLIENT_INPROGRESS: "Envoi client",
        "PR-CLIENT-INPROGRESS": "Envoyé au client",
        "TO-DELIVER": "A livrer",
        "CONTROL-DELIVERY-VALIDATED": "Livraison validée",
        "CONTROL-DELIVERY-FAILED": "Livraison refusée",
        DELIVERED: "Livraison finalisée",
        "SWITCH-TO-REPRO": "Passer en REPRO",
        BTN: {
            NEXT: {
                NONE: "Initialisée",
                READY: "Prêt",
                "CHECK-AUTO-CONTROL": "Auto-contrôle",
                "CHECK-QUALITY": "Ctrl qualité",
                "CHECK-REPRO": "Ctrl repro",
                "CHECK-PROD": "Ctrl graphique",
                "CHECK-CPP": "Ctrl CPP",
                RETURN_TO: "Retour à",
                CONTROL_APPROVED: "Contrôle validé",
                CONTROL_REJECTED: "Contrôle non validé",
                CONTROL_PENDING: "En attente de proofscope",
                "WAITING-AUTO-CONTROL": "Retour en production",
                "WAITING-CHECK-CPP": "Retour en production",
                "INTERN-FINISHED": "Contrôle CPP validé",
                "INTERN-FINISHED-OPERATOR": "Contrôle Opé. validé",
                "TEAM-CREATIF-INPROGRESS": "Envoyer à Team Créatif",
                "TEAM-CREATIF-FEEDBACK-INFO": "Avis Team Créatif",
                "TEAM-CREATIF-FEEDBACK-CLIENT": "Décision Team Créatif",
                "TEAM-CREATIF-APPROVED": "Valider la relecture",
                "TEAM-CREATIF-REJECTED": "Faire les corrections",
                "INTERNAL-MEMBERS-INPROGRESS": "Envoyer à Team Créatif",
                "INTERN-FINISHED-INTERNAL-MEMBERS": "Faire approuver par Team Créatif",
                "INTERNAL-MEMBERS-FEEDBACK-INFO": "Avis Team Créatif",
                "INTERNAL-MEMBERS-FEEDBACK-CLIENT": "Décision Team Créatif",
                "INTERNAL-MEMBERS-APPROVED": "Valider la relecture",
                "INTERNAL-MEMBERS-REJECTED": "Faire les corrections",
                PAUSED: "Pause",
                RESTART: "Reprendre",
                PR_CLIENT_INPROGRESS: "Envoi client",
                "PR-CLIENT-INPROGRESS": "Envoyer au client",
                "PROD-INTERN-REJECTED": "Auto ctrl rejeté",
                "CPP-INTERN-REJECTED": "Ctrl CPP rejeté",
                "CONTROL-VALIDATED": "Contrôle validé",
                "CONTROL-FAILED": "Contrôle refusé",
                WIP: "En production",
                "TO-DELIVER": "A livrer",
                "CONTROL-DELIVERY-VALIDATED": "Valider la livraison",
                "CONTROL-DELIVERY-FAILED": "Refuser la livraison",
                DELIVERED: "Finaliser la livraison",
                "RE-DELIVER": "Relivraison",
                "SWITCH-TO-REPRO": "Passer en REPRO"
            },
            PREVIOUS: {
                NONE: "Initialiser",
                READY: "Réinitialiser",
                "CHECK-AUTO-CONTROL": "Auto-contrôle",
                "CHECK-QUALITY": "Ctrl qualité",
                "CHECK-REPRO": "Ctrl repro",
                "CHECK-PROD": "Ctrl graphique",
                "CHECK-CPP": "Ctrl CPP",
                RETURN_TO: "Retour à",
                CONTROL_APPROVED: "Contrôle validé",
                CONTROL_REJECTED: "Contrôle non validé",
                CONTROL_PENDING: "En attente de proofscope",
                "WAITING-AUTO-CONTROL": "Retour en production",
                "WAITING-CHECK-CPP": "Retour en production",
                "INTERN-FINISHED": "Contrôle CPP validé",
                "INTERN-FINISHED-OPERATOR": "Contrôle Opé. validé",
                "TEAM-CREATIF-INPROGRESS": "Approbation Team Créatif",
                "TEAM-CREATIF-FEEDBACK-INFO": "Avis Team Créatif",
                "TEAM-CREATIF-FEEDBACK-CLIENT": "Décision Team Créatif",
                "TEAM-CREATIF-APPROVED": "Valider la relecture",
                "TEAM-CREATIF-REJECTED": "Faire les corrections",
                "INTERNAL-MEMBERS-INPROGRESS": "Approbation Team Créatif",
                "INTERN-FINISHED-INTERNAL-MEMBERS": "Approbation Team Créatif validé",
                "INTERNAL-MEMBERS-FEEDBACK-INFO": "Avis Team Créatif",
                "INTERNAL-MEMBERS-FEEDBACK-CLIENT": "Décision Team Créatif",
                "INTERNAL-MEMBERS-APPROVED": "Valider la relecture",
                "INTERNAL-MEMBERS-REJECTED": "Faire les corrections",
                PAUSED: "Approbation TC en pause",
                PR_CLIENT_INPROGRESS: "Envoi client",
                "PR-CLIENT-INPROGRESS": "Envoyé au client",
                "PROD-INTERN-REJECTED": "Auto ctrl rejeté",
                "CPP-INTERN-REJECTED": "Ctrl CPP rejeté",
                "CONTROL-VALIDATED": "Contrôle validé",
                "CONTROL-FAILED": "Contrôle refusé",
                WIP: "Retour en production",
                "TO-DELIVER": "Réinitialiser la livraison",
                "RE-DELIVER": "Relivraison",
                "CONTROL-DELIVERY-VALIDATED": "Retour en livraison validée",
                "CONTROL-DELIVERY-FAILED": "Retour en livraison refusée",
                DELIVERED: "Finaliser la livraison",
                "SWITCH-TO-REPRO": "Passer en REPRO"
            }
        },
        DASHBOARD: {
            NULL: "Pas de relecture interne",
            NONE: "Brief en cours",
            UPDATE_DOC: "Doc modifié",
            READY: "Prêt",
            "CHECK-AUTO-CONTROL": "Auto-contrôle",
            APPROVED: "Approuvé",
            REJECTED: "Rejeté",
            "CHECK-QUALITY": "Ctrl qualité",
            "CHECK-REPRO": "Ctrl repro",
            "CHECK-PROD": "Ctrl graphique",
            "CHECK-CPP": "Ctrl CPP",
            WIP: "En production",
            CONTROL_APPROVED: "Ctrl validé",
            CONTROL_REJECTED: "Ctrl non validé",
            CONTROL_PENDING: "ATT proofscope",
            "WAITING-AUTO-CONTROL": "Modifs auto-ctrl",
            "WAITING-CHECK-CPP": "Modifs Ctrl CPP",
            "INTERN-FINISHED": "Contrôle CPP validé",
            "INTERN-FINISHED-OPERATOR": "Contrôle Opé. validé",
            "TEAM-CREATIF-INPROGRESS": "Approbation Team Créatif",
            "TEAM-CREATIF-FEEDBACK-INFO": "Avis Team Créatif",
            "TEAM-CREATIF-FEEDBACK-CLIENT": "Décision Team Créatif",
            "TEAM-CREATIF-APPROVED": "Team Créatif validé",
            "TEAM-CREATIF-REJECTED": "Team Créatif refusé",
            "INTERNAL-MEMBERS-INPROGRESS": "Approbation Team Créatif",
            "INTERN-FINISHED-INTERNAL-MEMBERS": "Approbation Team Créatif validé",
            "INTERNAL-MEMBERS-FEEDBACK-INFO": "Avis Team Créatif",
            "INTERNAL-MEMBERS-FEEDBACK-CLIENT": "Décision Team Créatif",
            "INTERNAL-MEMBERS-APPROVED": "Team Créatif validé",
            "INTERNAL-MEMBERS-REJECTED": "Team Créatif refusé",
            PAUSED: "Approbation TC en pause",
            "PROD-INTERN-REJECTED": "Auto ctrl rejeté",
            "CPP-INTERN-REJECTED": "Ctrl CPP rejeté",
            "CONTROL-VALIDATED": "Contrôle validé",
            "CONTROL-FAILED": "Contrôle refusé",
            PR_CLIENT_INPROGRESS: "Envoi client",
            "PR-CLIENT-INPROGRESS": "Envoyé au client",
            GENERATING: "Génération en cours",
            RELECTURE_IN_PROGRESS: "Relecture client en cours",
            "TO-DELIVER": "A livrer",
            "CONTROL-DELIVERY-VALIDATED": "Livraison validée",
            "CONTROL-DELIVERY-FAILED": "Livraison refusée",
            DELIVERED: "Livraison finalisée",
            "RE-DELIVER": "Relivré",
            "SWITCH-TO-REPRO": "Passer en REPRO"
        },
        APPROVE: {
            NONE: "Brief en cours",
            READY: "Document prêt pour la production.",
            CONTROL_TO_CPP: "À valider par le CPP",
            CONTROL_TO_QUALITY: "À valider par le ctrl qualité",
            CPP: "Ctrl validé",
            "INTERN-FINISHED": "Voulez-vous valider le contrôle CPP ?",
            "INTERN-FINISHED-OPERATOR": "Voulez-vous valider le contrôle Opé. ?",
            "TEAM-CREATIF-INPROGRESS": "Voulez-vous lancer l'approbation Team Créatif ?",
            "TEAM-CREATIF-APPROVED": "Voulez-vous valider l'approbation Team Créatif ?",
            "TEAM-CREATIF-REJECTED": "Voulez-vous refuser l'approbation Team Créatif ?",
            "INTERNAL-MEMBERS-INPROGRESS": "Voulez-vous lancer l'approbation Team Créatif ?",
            "INTERN-FINISHED-INTERNAL-MEMBERS": "Voulez-vous valider l'approbation Team Créatif ?",
            "INTERNAL-MEMBERS-APPROVED": "Voulez-vous valider l'approbation Team Créatif ?",
            "INTERNAL-MEMBERS-REJECTED": "Voulez-vous refuser l'approbation Team Créatif ?",
            PAUSED: "Voulez-vous mettre l'approbation TC en pause ?",
            "PR-CLIENT-INPROGRESS": "Envoyer la relecture au client",
            "CHECK-AUTO-CONTROL": "Document modifié, à valider en auto-contrôle",
            "CHECK-QUALITY": "Document ok, à valider par le Ctrl qualité",
            "CHECK-REPRO": "Document ok, à valider par le Ctrl repro",
            "CHECK-PROD": "Document ok, à valider par le Ctrl graphique",
            "CHECK-CPP": "Document ok, à valider par le CPP",
            "PROD-INTERN-REJECTED": "Rejeter l'auto-contrôle",
            "CPP-INTERN-REJECTED": "Rejeter le contrôle du CPP",
            WIP: "Passer le job en production",
            "CONTROL-FAILED": "Document contrôlé, déclaré non valide.",
            "CONTROL-VALIDATED": "Document contrôlé, déclaré valide.",
            "TO-DELIVER": "Initialiser la livraison",
            "CONTROL-DELIVERY-VALIDATED": "Retour en livraison valide",
            "CONTROL-DELIVERY-FAILED": "La livraison est non-conforme",
            DELIVERED: "Contrôlez pour voir si tout s'est bien passé ! Si oui, poursuivez, sinon réinitialisez la livraison.",
            "RE-DELIVER": "Voulez-vous relivrer le job ?",
            "SWITCH-TO-REPRO": "Voulez-vous passer en REPRO ?"
        },
        REJECT: {
            QUALITY: "Ctrl qualité non validé",
            GRAPHIC: "Ctrl graphique non validé",
            OPERATOR: "Auto-contrôle non validé",
            REJECT: "Ctrl non validé",
            DOCUMENT: "Document à modifier",
            "CHECK-CPP": "Document à valider par le CPP"
        }
    },
    LINK_MASTER_REFERENCE: "Liaison entre projet parent et enfant",
    MAIL: "Email",
    TABLE_PROJECT: "Mes projets",
    TABLE_REQUESTS: "Mes demandes",
    MENU: {
        USERS: "Utilisateurs",
        GROUPS: "Groupes",
        MY_ACCOUNT: "Mon compte",
        PROJECTS: "Projets",
        LOG_OUT: "Déconnexion",
        COLORS: "Nuanciers",
        COLORBOOKS: "Nuancier (couleurs)",
        FINISHBOOKS: "Nuancier (finitions)",
        OPEN_FOLDER: "Ouvrir le dossier",
        BRIEF: "Fiche de brief",
        CREATE: "Créer une fiche textes",
        CREATE_CHILD: "Créer un projet enfant",
        CREATE_MASTER: "Créer un projet parent",
        CREATE_PRINTER: "Créer un imprimeur",
        CREATE_PROJECT: "Créer un projet",
        CREATE_REQUEST: "Créer une demande",
        CREATE_USER: "Créer un utilisateur",
        EDIT_PROJECT: "Éditer un projet enfant",
        EXPORT_CSV: "Exporter CSV",
        EXPORT_CSV_LOADING: "Export en cours...",
        SUPPORT: "Support",
        PROFIL: "Mon compte",
        CONTACT: "Contact",
        FORM: "Fiches textes",
        KIOSK: "Cloudflow",
        MARQUES: "Marques",
        PATCH_NOTES: "Notes de mise à jour",
        MENU: "Menu",
        MANAGE: "Gérer",
        EPSON: "Epson",
        EASYDIADEM: "EasyDiadem",
        PRINTER: "Imprimeurs",
        HOME: "Accueil",
        PROJECT: "Projet",
        ARCHIVES: "Archivages",
        SPLITVIEW: "Relecture client",
        TABLE_PROJECT: "Mes projets",
        TABLE_PRINTER: "Imprimeurs",
        TABLE_USER: "Utilisateurs",
        UPDATE: "Éditer une fiche textes",
        ACCOUNT: "Mon compte",
        STATS: "KPI",
        ED: {
            ED_REQUESTS: "Mes demandes",
            NEW_REQUEST: "Nouvelle demande"
        }
    },
    PREVIEW_CARTOUCHE: {
        NUM_JOB: "Numéro de job",
        RANGE: "Marque",
        FOLDER: "Dossier",
        DATE: "Date",
        REPRO_OPERATOR: "Infographiste REPRO",
        EXE_OPERATOR: "Infographiste EXE",
        IMAGE: "Imports images",
        GENCOD: "Gencod",
        PRINTER: "Imprimeur",
        PRINT: "Impression",
        PLAN: "Plan",
        SUPPORT: "Support",
        PROFIL: "Profil"
    },
    PROJECT: {
        ERROR_CREATE_MISSING_MASTER: "Veiullez selectionner un projet parent",
        ERROR_CREATE: "Impossible de créer le projet",
        RESET_MASTER_JOB: "Changer de job maître",
        COLORS: "Mise en Couleurs",
        NEW_MASTER_PROJECT: "Nouveau projet maître",
        EDIT_MASTER_PROJECT: "Editer le projet maître",
        NEW_PROJECT: "Nouveau projet",
        EDIT_PROJECT: "Editer le projet",
        ALL_CUSTOMER: "Tous les clients",
        CHILD_IDENTIFIER: "Identifiant du projet",
        JOB_FLUX_REQUIRED: "Le flux de travail est requis",
        CREATED: "Nouveau projet créé",
        EDITED: "Projet sauvegardé",
        MEMBERS: {
            TITLE: "Membres du projet",
            LABEL: "Ajouter des membres...",
            LEGEND: "Les membres définis ici seront utilisés pour les futures relectures créées à partir du projet. Ensuite, les membres se gèrent directement dans chaque relecture et sont indépendants du projet.",
            FILTER_PLACEHOLDER: "Rechercher un utilisateur...",
            TABLE: {
                NAME: "NOM",
                PROOFSCOPE: "DOC",
                TEXTS: "TEXTES",
                APPROVERS: "AVIS",
                VERSIONS: "VERSIONS",
                EMAIL: "E-MAIL",
                ORDER: "ORDRE",
                READ: "Lecture",
                WRITE: "Ecriture",
                INFO: "Info",
                PREEMPTIVE_RIGHT: "PREEMPT.",
                PREEMPTIVE_RIGHT_LONG: "Droit de préemption",
                TOOLTIP: {
                    PROOFSCOPE:
                        'Attribuez l\'option "Lecture" pour permettre au relecteur de voir le document, et "Écriture" pour permettre au relecteur d\'ajouter des commentaires sur le document.',
                    TEXTS: 'Attribuez l\'option "Lecture" pour permettre au relecteur de consulter les textes, et "Écriture" pour lui permettre d\'ajouter des textes au document.',
                    APPROBATION:
                        'Attribuez l\'approbation "info" pour permettre au relecteur de donner son avis. L\'approbateur "document" sera le décideur final.',
                    EMAIL: "Activez les notifications de l'utilisateur. Il sera prévenu par email.",
                    PREEMPTIVE_RIGHT:
                        "Attribuez ce droit à un membre pour qu'il puisse décider de l'arrêt de la relecture. S'il rejette la relecture, celle-ci ne sera pas transmise aux autres relecteurs.",
                    ORDER: "Indiquez un chiffre pour définir l’ordre de passage de chaque relecteur (sans chiffre, l’ordre sera par défaut à 0). La relecture passera automatiquement au suivant une fois que le précédent aura donné son avis.",
                    VERSIONS:
                        "Attribuez au relecteur la possibilité de comparer le document avec les anciennes versions et de voir les commentaires précédents."
                },

                DOCUMENT: "Document",
                ERROR: {
                    ATLEASTONEMEMBER: "• Au moins un membre requis",
                    APPRODOC: "• Aucun membre n'est désigné approbateur du document",
                    ATLEASTONEINFO: "• Au moins un approbateur pour information requis",
                    MAXIMUMONE: "• Il ne peut y avoir qu'un unique approbateur du document"
                }
            }
        },
        TEAM_CREATIF_MEMBERS: {
            TITLE: "Approbateurs Team Créatif",
            ENABLE: "Activer l'approbation Team Créatif",
            LEGEND: "Ces membres seront utilisés pour le circuit d'approbation interne Team Créatif des futures relectures EXE, HD et CREA. Ils sont séparés des approbateurs externes."
        },
        CART: {
            CART: "Cartouche",
            FILETMINNEG: "Filet minimum négatif",
            FILETMINPOS: "Filet minimum positif",
            HAUTCHIFFREPOIDS: "Hauteur des chiffres poids/volumes.",
            HAUTEMETRO: "Hauteur E Métrologique",
            HAUTXMIN: "Hauteur de x minuscule",
            MINTXTNEG: "Texte minimum négatif",
            MINTXTPOS: "Texte minimum positif",
            POLICEUSED: "Police utilisée",
            PREFILL: "Pré-remplir cartouche",
            SHOW_PREVIEW: "Regénérer la prévisualisation",
            SHOW_PREVIEW_EXE: "Cartouche EXE",
            SHOW_PREVIEW_REPRO: "Cartouche REPRO",
            GENERATE_PREVIEW: "Générer le cartouche",
            GENERATING_FILE: "Génération du fichier",
            ERROR_GENERATING_FILE: "Erreur lors de la génération du fichier"
        },
        CHILD: "Projet enfant",
        COMM: {
            CHROM: "Commentaire Chromie",
            COMM: "Commentaires",
            CPP: "Commentaire CPP",
            GAMME: "Commentaire Gamme",
            HD: "Commentaire HD",
            IMP: "Commentaire Imprimeur",
            PREPA: "Commentaire Preparation"
        },
        CREA: {
            COMM: "Commentaire",
            CREA: "Créa",
            INFO: "Informations"
        },
        CREATE: "Créer projet",
        CREATED_AT: "créé le",
        EXE: {
            CUSTOMER_COMMENT: "Commentaire client",
            BOOKPACK: "Bookpack",
            CHARTE: "Charte Client",
            COMM_CPP: "Commentaire CPP",
            BRIEF: "Brief Exe",
            IMG_BRIEF: "Brief Image",
            DEF: "Définition",
            EXE: "Exe",
            IMAGE: "Image",
            LANGUES: "Ordre des langues",
            LOGO: "Logo à executer",
            NB_LANGUES: "Nombre de langues",
            OPERATOR: "Infographiste Exe",
            SOFT: "Logiciels",
            NB_LANGUE_SET_IN_TEXTS: "Le nombre et l'ordre des langues doit être défini dans la fiche textes",
            TEXTS: {
                ARCHIVE: "Archive",
                BRIEF: "Brief Client/Team",
                CLIENT: "Fiche Texte Client",
                CREA: "Créa",
                TEXTS: "Textes"
            }
        },
        FILTERS: {
            OLD_PROJECTS: "Anciens projets",
            PROJECTS_ARCHIVED: "Projets archivés",
            IN_APPROVAL_STATUS: "En attente de validation",
            DISPLAY_CLOSED: "Afficher les requêtes déjà traitées",
            MY_PROJECTS: "Mes projets",
            ALL_PROJECTS: "Tous les projets",
            PROJECTS: "Projets en cours",
            DATE: "Date",
            DATES: "Dates",
            DATE_RANGE: {
                START_DATE: "Début",
                END_DATE: "Fin"
            },
            DATE_RANGE_ERRORS: {
                START_DATE: "Début",
                END_DATE: "Fin"
            },
            RESET: "Réinitialiser",
            SEARCH: "Lancer la recherche",
            REQUEST_TYPE_LABEL: "Type de requête",
            REQUEST_TYPE: {
                NONE: "Aucun",
                VISUALS_ISOLATION: "Isolation de visuel",
                PDF_REPOSITORY: "Dépôts de PDF"
            },
            REDELIVERY_TYPE_LABEL: "Type de relivraison",
            REDELIVERY_TYPE: {
                EXE: "EXE",
                REPRO: "REPRO",
                CREA: "CREA",
                HD: "HD",
                EZD_PDF_REPOSITORY: "EZD Dépôt de PDF"
            }
        },
        HD: {
            ARCHIVE: "Reprise d’archive",
            COMMCUSTOMER: "Brief HD",
            ELEMENTS: "Éléments pour la HD",
            HD: "HD",
            HDSHOOT: "Shutter",
            OPERATOR: "Infographiste HD",
            PLANNING: {
                EPSON: "Epson 1 Client / TC",
                LIVRAISON: "Livraison",
                PLANNING: "Planning",
                R0: "R0 Master",
                R1: "R1 Master"
            },
            SHOOTCUSTOMER: "Shoot Client",
            SHOOTER: "Shoot HD",
            IA: "IA"
        },
        INFO: {
            DECOR_TYPE: "Type de décor",
            FRONT_ONLY: "Recto seul",
            FRONT_AND_REVERSE: "Recto/Verso",
            FLOWS: "Flux",
            INFO_MASTER: "Informations générales projet maître",
            AGENCE: "Agence",
            APPROVER1: "Approbateur 1",
            APPROVER2: "Approbateur 2",
            APPROVER3: "Approbateur 3",
            APPROVER4: "Approbateur 4",
            APPROVERS: "Approbateurs",
            MEMBERS: "Membres",
            ARCHIVE: "Archive",
            BASE: "Base de travail",
            CHILD: "Numéro Enfant",
            CODEARTICLE: "Code Article",
            CONTACT: "Contact",
            CONTRAINTE: "Contraintes Techniques (imprimeur)",
            CPP: "CPP",
            CREA: "Créa",
            CREA_NAME: "Nom + N°Créa",
            CREA_TYPE: "Type de créa",
            CUSTOMER: "Client",
            CUSTOMER_INVOICE: "Client facturation (optionnel)",
            CUSTOMER_CODE: "Code client",
            DATEVALID: "Date validation",
            DESIGNATION: "Désignation",
            DESIGNATIONGAMME: "Désignation",
            DESIGNATION_PRODUIT: "Désignation produit",
            FAMILY: "Famille",
            FILETMINN: "Filet mini Négatif",
            FILETMINP: "Filet mini Positif",
            IDENTIFIANT: "Identifiant",
            IDENTIFIER: "Numéro du Job Enfant",
            IDMAITRE: "Numéro Job Maître",
            INFO: "Informations Générales",
            LANGUAGES: "Langues",
            MASTER: "Numéro Master",
            NUMCREA: "N° Créa validée",
            NUMDIADEM: "Numéro Diadem",
            NUMTEAM: "Numéro Team Créatif",
            OPERATOR: "Infographiste référent",
            PLAN: "Plan",
            PRINT: "Impression",
            PRINTER: "Imprimeur",
            PROCESS: "Process",
            RANGE: "Marque",
            REFNUMBER: "Nombre de référence",
            RELECTURE_JOB: "Numéro de relecture",
            RELECTURE_JOB_EXE: "N° de relecture EXE",
            RELECTURE_JOB_REPRO: "N° de version REPRO",
            SERVICE: "Services",
            STATUS: "Statut",
            SUPPORT: "Support",
            TEXTMININ: "Textes mini Négatif",
            TEXTMINIP: "Textes mini Positif",
            TYPEJOB: "Type",
            ZONEDEBORDDEV: "Zone débord Developpement",
            ZONEDEBORDLAIZE: "Zone débord Laize",
            ZONESECUCOUP: "Zone sécurité coupe",
            ZONESECURAIN: "Zone sécurité raineur",
            SUPPORT_COMM: "Spécificités imprimeur",
            RIVERFLOW: "Riverflow",
            RIVERFLOW_JOBTYPES: "Type de job a créer",
            RIVERFLOW_DATE: "Date du Job",
            CREATE_IN_RIVERFLOW: "Créer le Job dans Riverflow",
            RIVERFLOW_THOSE_TYPE_ARE_LOCKED: "Les types de job suivants sont verrouillés pour cette date :",
            COMM_CREA: "Commentaire Créa",
            CATEGORY: "Catégorie",
            SUB_CATEGORY: "Sous-catégorie"
        },
        PDF_REPO: "Dépôt de PDF",
        LAST_REVISION: "Dernier Ctrl client (exe) le",
        LAST_VERSION: "Dernier Ctrl client (repro) le",
        MASTER: {
            SAVED: "Projet maître sauvegardé",
            CREATED: "Le projet maitre à été créé",
            ERROR: "Une erreur est survenue"
        },
        OTHER: "Autre",
        OTHER_COMMENT: "Commentaire",
        PREFILL: "Pré-remplir les champs",
        PREFILL_MASTER: "Pré-remplir le projet maître",
        EASYDIADEM: "Easydiadem",
        REPRO: {
            CHROMIE: {
                CHROMIE: "Chromie",
                CIBLE: "Cible couleur fournie",
                ENCR: "Encrage maximum",
                PTMAX: "Point maxi",
                PTMIN: "Point mini",
                REPROPROFIL: "Profil",
                TRAM: "Trame"
            },
            FILE1: "Fichiers à fournir",
            FILE2: "PSD",
            OPERATOR: "Infographiste REPRO",
            REPRO: "REPRO",
            RETRAIT: {
                BLANC: "Retrait blanc",
                COULEUR: "Retrait couleur",
                VERNIS: "Retrait Vernis"
            },
            TRAP: "Trapping",
            TRAP_RETRAIT: "Trapping et Retrait"
        },
        SAVE: "Sauvegarder projet",
        SEARCH: "Rechercher un projet...",
        TYPE_JOB_REQUIRED: "Type de job requis",
        FLOWS: {
            EXE: "Exe",
            REPRO: "Repro",
            HD: "Hd",
            CREA: "Créa",
            PDF_REPO: "Dépôt de PDF",
            BAT: "BAT",
            OTHER: "Autre"
        }
    },
    MASTER: {
        SAVED: "Projet maître sauvegardé",
        CREATED: "Le projet maitre à été créé",
        ERROR: "Une erreur est survenue"
    },
    PROJECTS: "Projets",
    PROJECTTABLE: {
        PAGE_TITLE: "Table des projets"
    },
    FACE: "De Face",
    "THREE-QUARTER-LEFT": " De 3/4 à gauche",
    "THREE-QUARTER-RIGHT": " De 3/4 à droite",
    "FACE-INCO": "Face légale INCO",
    RESTART: "Redémarrer",
    REQUIRED: "Champ requis",
    PR_REQUIRED: "EXE : Penser à créer une fiche texte (pour éviter le plantage de flux)",
    RESET_DIALOG: {
        TEXT: "Les textes et les champs personnalisés seront supprimés dans toutes les langues",
        TITLE: "Voulez-vous réinitialiser la fiche textes ?"
    },
    SAVE: "Sauvegarder",
    SELECT_JOB_CHILD_REFERENCE: "Sélectionner un projet enfant",
    SELECT_JOB_MASTER_REFERENCE: "Sélectionner un projet parent",
    SELECT_FILTER_FIELDS: "Cliquez ici pour sélectionner les champs de la fiche textes",
    SELECT_REFERENCE: "Sélectionner une référence",
    SHOOTING: "Quelle(s) prise(s) de vue pour votre Packshot (il sera livré aux formats jpeg, png - Basse déf et Haute déf) : ",
    SELECT_SHOOTING: "Merci de sélectionner les prises de vue",
    SOMETHING_WENT_WRONG: "Une erreur est survenue",
    SPLITVIEW: {
        PAGE_TITLE: "VUE COMPAREÉ"
    },
    SUBMIT: "Envoyer",
    SUCCESS: {
        CREATE: "Vos textes ont été créés",
        FORM: {
            CREATE: "Votre fiche textes a été créée",
            SAVE: "Votre fiche textes a été enregistré",
            SUBMIT: "Fiche textes envoyée !"
        },
        SAVE: "Vos textes ont été enregistrés",
        SUBMIT: "Textes envoyés !"
    },
    SYSTEM: "Système",
    TABLE: "Tableau des projets",
    COMPARE: "Comparer",
    TEL: "Téléphone",
    TEXT: {
        COPIED: "Texte copié !",
        COPIED_IDENTIFIER: "Identifiant copié !",
        PASTED: "Texte collé depuis le presse papier"
    },
    TEXTOK: {
        SUBMIT: "Textes envoyés !",
        TITLE: "Textes ok"
    },
    TEXT_APPRO_IN_PROGRESS: "Traitement approbateurs",
    TEXT_IN_PROGRESS: "En cours de traitement",
    TEXT_SEND: "Textes envoyés",
    TITLE: "TITRE",
    ARE_YOU_SURE: "Êtes-vous sûr ?",
    ARE_YOU_SURE_DELETE_GROUP_TEXT: "Le groupe sera supprimé. (Les groupes supprimés seront retirés des projets en cours)",
    ARE_YOU_SURE_DELETE_LANGUAGES: "Les textes de cette langue seront supprimés",
    DELETE: "Supprimer",
    TOOLBAR: {
        IN_PRODUCTION: "Envoyer en production",
        CREATE: "Créer fiche textes",
        FIELD: "Ajouter un champ personnalisé",
        CUSTOM_COLUMN: "Ajouter une colonne personnalisé",
        LANGUAGE: "Ajouter une langue",
        FORM: "Réinitialiser la fiche textes",
        PREFILL: "Pré-remplir les champs",
        SUBMIT: "Envoyer la fiche textes",
        SUBMIT_MODIF: "Envoyer les modifications"
    },
    TRAME: "Linéature de trame",
    TYPE_TRAME: "Type de Trame",
    TXT_SUBMIT: "Textes envoyés",
    TYPE: "File Epson",
    UNSAVED_CHANGES: "Des modifications n'ont pas été sauvegardées. Quitter quand même ?",
    USERS: "Utilisateurs",
    GROUPS: "Groupes",
    USER: {
        ARE_YOU_SURE_DELETE_USER_TEXT: "L'utilisateur sera supprimé",
        BOTH_USED: "Nom d'utilisateur et e-mail déjà utilisés",
        CREATE: "Créer l'utilisateur",
        CREATE_OTHER: "Souhaitez-vous créer un autre utilisateur ?",
        CREATE_USER: "Créer un utilisateur",
        ADD_USER: "Ajouter un utilisateur",
        CUSTOMER: "Client",
        DELETE: "Supprimer",
        DELETE_SUCCESS: "Utilisateur supprimé",
        EDIT_ACCOUNT_SUCCESS: "Compte mis à jour",
        EDIT_SUCCESS: "Utilisateur mis à jour",
        ADD_SUCCESS: "Utilisateur créé",
        EDIT_FAILED: "Impossible de mettre à jour l'utilisateur",
        EDIT_USER: "Éditer l'utilisateur",
        EMAIL: "E-mail",
        FIRSTNAME: "Prénom",
        MANAGE_USERS: "Gérer les utilisateurs",
        GROUP: "Groupe",
        LASTNAME: "Nom",
        MAIL_USED: "E-mail déjà utilisé",
        MY_ACCOUNT: "Mon compte",
        RESET_PASSWORD_SUCCESS: "Mot de passe réinitialisé",
        PASSWORD: {
            CURRENT: "Mot de passe actuel",
            NEW: "Nouveau mot de passe",
            NEW_CONFIRM: "Confirmer le nouveau mot de passe",
            NOT_SAME: "Les deux mots de passe sont différents",
            RESET: "Modifier mon mot de passe",
            UPDATE_SUCCESS: "Mot de passe mis à jour",
            WRONG_CURRENT: "Mot de passe actuel incorrect"
        },
        UPDATE: "Mettre à jour",
        USER: "Utilisateur",
        USERNAME: "Login",
        USERNAME_USED: "Nom d'utilisateur déjà utilisé",
        IS_DIADEM: "L'utilisateur fait partie de Diadem",
        IS_DIADEM_SHORT: "Utilisateurs Diadem"
    },
    USERNAME: "Nom d'utilisateur",
    SELECT_DOC: "Merci de sélectionner un document",
    ACTION_REQUIRED: {
        TITLE: "Action requise"
    },
    GROUP: {
        STATE: "Etat de la relecture",
        INTERN_STATE: "Etat interne",
        ASSESSMENT: "Mon avis",
        DELETE_SUCCESS: "Groupe supprimé",
        CREATE: "Créer le groupe",
        CREATE_GROUP: "Ajouter un groupe",
        CUSTOMER: "Client",
        CUSTOMERS: "Clients",
        CPP: "CPP",
        MANAGE_GROUPS: "Gérer les groupes",
        BRANDS: "Marques",
        DELETE: "Supprimer",
        EDIT_GROUP: "Éditer le groupe",
        EDIT_SUCCESS: "Groupe mis à jour",
        CREATE_SUCCESS: "Groupe créé",
        GROUP: "Groupe",
        UPDATE: "Mettre à jour",
        NAME: "Nom",
        USERS: "Utilisateurs",
        APPROBATION_BEHAVIOR: "Comportement d'approbation",
        ONE_FOR_ALL: "Un vaut pour tous",
        INDIVIDUAL: "Individuel",
        ONE_FOR_ALL_DESCR:
            "N'importe quel membre du groupe peut choisir de valider/rejeter l'approbation, et suite à son choix le statut de tout le groupe est affecté en conséquence.",
        INDIVIDUAL_DESCR:
            "Chaque membre du groupe doit valider/rejeter l'approbation avant que le statut du groupe soit calculé en conséquence."
    },
    INVALID_FILE: "Le fichier est invalide",
    INVALID_FILE_SIZE: "Le fichier est trop volumineux",
    INVALID_FILE_TYPE: "Le type du fichier est incorrecte",
    VALID: "Valider",
    VALIDATORS: {
        "FORMDIALOG-CPP": "Veuillez sélectionner un CPP valide",
        "FORMDIALOG-PRINTERS": "Veuillez sélectionner un imprimeur valide",
        "FORMDIALOG-CUSTOMER": "Veuillez sélectionner un client valide",
        "FORMDIALOG-IDENTIFIANT": "Veuillez sélectionner un identifiant valide",
        "FORMDIALOG-FAMILY": "Veuillez sélectionner une famille valide",
        "FORMDIALOG-FORM": "Veuillez saisir un nom de champ",
        "FORMDIALOG-LANGUAGE": "Veuillez sélectionner au moins une langue",
        "FORMDIALOG-OPERATOR": "Veuillez sélectionner un infographiste valide",
        "FORMDIALOG-PROJECT": "Veuillez sélectionner un projet valide",
        "FORMDIALOG-RANGE": "Veuillez sélectionner une marque valide",
        "FORMDIALOG-CONTACT": "Veuillez sélectionner un contact valide",
        "FORMDIALOG-CUSTOMER_INVOICE": "Veuillez sélectionner un client de facturation valide",
        NO_WHITESPACE_ALLOWED: "Les espaces ne sont pas autorisés"
    },
    VALID_EMAIL: "Email non valide",
    INVALID_USERNAME: "Username invalide",
    INVALID_PASSWORD: "Mot de passe invalide",
    VALID_TEL: "Téléphone non valide",
    VIEW: {
        BUTTON: "Voir",
        PROJECT_REF: "Référence",
        ID_MAITRE: "ID Maître",
        COMPARE: "Comparer",
        DOCUMENT_APPROVER_REJECT: "L'approbateur a rejeté le document.",
        DOCUMENT_YOU_ACCEPT: "Vous avez accepté le document.",
        DOCUMENT_YOU_REJECT: "Vous avez rejeté le document.",
        DOCUMENT_APPROVER_ACCEPT: "L'approbateur a approuvé le document.",
        INTERNAL_MEMBERS_REJECT: "Team Créatif a rejeté le document.",
        INTERNAL_MEMBERS_ACCEPT: "Team Créatif a approuvé le document.",
        INTERNAL_MEMBERS_YOU_REJECT: "Vous avez rejeté le document.",
        INTERNAL_MEMBERS_YOU_ACCEPT: "Vous avez accepté le document.",
        INTERN_CONTROL_REJECT: "Le contrôle interne a été rejeté.",
        INTERN_CONTROL_APPROVED: "Le contrôle interne a été approuvé.",
        DOCUMENT_IN_PRODUCTION: "Le document est en cours de production.",
        PENDING_DELIVERY: "En attente de livraison"
    },
    WARNING: "Attention",
    WARNING_DELETE_OTHER_FLOW: "Attention : cela supprimera tous les autres relectures lors de la sauvegarde du projet",
    WARNING_DELETE_FLOW: "Attention : cela supprimera cette relecture lors de l'enregistrement du projet",
    REPRO_IN_PROGRESS: "REPRO en cours",
    EXE_IN_PROGRESS: "Exe en cours",
    YES: "Oui",
    NO: "Non",
    ENTER_VALUE: "Entrez une valeur",
    EDIT: "Editer",
    MUST_BE_IN_LIST: "L'element doit etre issue de la liste",
    SYNCBDD: "Synchroniser la base client Logipub",
    TXT_PR: "Fiche Textes",
    VALIDATE: "Valider",
    NEXT: "Suivant",
    PREVIOUS: "Précédent",
    REMOVE_LANGUE: "Supprimer la langue",
    SEARCH: "Rechercher",
    SELECT_LANGUAGE: "Sélectionner une ou plusieurs langues",
    SERVICE: {
        PROJECT: "Projets",
        VALIDATORS: {
            PROJECT: "Veuillez sélectionner un projet valide",
            PRINTERS: "Veuillez sélectionner un imprimeur valide"
        },
        PRINTERS: "Imprimeurs"
    },
    NOTIFICATIONS: {
        LIST: "Notifications",
        CARTOUCHE_GENERATED: "Le cartouche {{ type }} du projet {{ projectIdentifier }} a été généré !",
        PROOFSCOPE_GENERATED: "{{ identifier }} - La relecture interne {{ flow }} à été mis-à-jour !",
        FILE_VALIDED: "{{ identifier }} - La relecture interne {{ flow }} est terminée !",
        SENT_TO_CLIENT: "{{ identifier }} - La relecture interne a été publiée au client",
        CHECK_CPP: "{{ identifier }} - Un job dont vous êtes CPP est prêt à être contrôlé.",
        BRIEF_FILES_ARE_READY: "{{ identifier }} - Les fichiers du brief client ont été copiés",
        FILES_ARE_READY: "{{ identifier }} - Les fichiers ont été copiés",
        START_DELIVERY: "{{ identifier }} - La livraison est prête à être contrôlée",
        CONTROL_DELIVERY_VALIDATED: "{{ identifier }} - Contrôle de livraison terminé, livraison validée",
        CONTROL_DELIVERY_FAILED: "{{ identifier }} - Contrôle de livraison terminé, livraison refusée",
        FINAL_DELIVERY: "{{ identifier }} - La livraison a été finalisée",
        ERROR: {
            UPDATE_DOC: "{{ identifier }} - Le flux de production a planté en {{ flow }}",
            VALID_FILE: "{{ identifier }} - Le flux de validation du fichier a planté en {{ flow }}",
            BRIEF_FILES_ARE_READY: "{{ identifier }} - Les fichiers n'ont pas pu être copiés",
            FILES_ARE_READY: "{{ identifier }} - Les fichiers n'ont pas pu être copiés",
            START_DELIVERY: "{{ identifier }} - La livraison a planté en {{ flow }}",
            RELECTURE_MEMBER: "{{ identifier }} - La mise à jour des membres dans la relecture a planté",
            CONTROL_DELIVERY_FAILED: "{{ identifier }} - Le refus du contrôle de livraison a planté en {{ flow }}",
            CONTROL_DELIVERY_VALIDATED: "{{ identifier }} - La validation du contrôle de livraison a planté en {{ flow }}",
            FINAL_DELIVERY: "{{ identifier }} - La finalisation de la livraison a planté en {{ flow }}",
            POST_VALIDATION: "{{ identifier }} - La post-validation a échoué en {{ flow }}. Relancez-la.",
            POST_VALIDATION_FILE_OPEN: "{{ identifier }} - La post-validation a échoué en {{ flow }} : {{#fileName}}\"{{ fileName }}\"{{/fileName}}{{^fileName}}un fichier{{/fileName}} est ouvert sur un autre poste. Fermez-le puis relancez.",
        }
    },
    JOB_NO_PROOFSCOPE: "Ce job n'a pas de fiche textes associée",
    EPSON: {
        PRINT: "Imprimer en Epson",
        GENERATING: "Génération du PDF Epson en cours…",
        NO_SOURCE: "Pas encore de PDF HD cartouché : envoyez une version en relecture, ou imprimez un fichier depuis Gérer > Epson",
        TO_CHECK: "PDF Epson à vérifier avant impression",
        STARTED: "Génération du PDF Epson lancée",
        SENT_TO_HOTFOLDER: "PDF Epson envoyé à l'impression",
        REJECTED: "PDF Epson non conforme",
        ERROR: "Erreur lors du traitement de l'Epson",
        CONFIRM: {
            TITLE: "PDF EPSON sur Dossier",
            TEXT: "Le PDF haute définition va être généré, puis vous pourrez le vérifier avant impression.",
            PROFILE: "Destination",
            CARTOUCHE: "Cartouche",
            GENERATING_HINT: "Vous pouvez fermer cette fenêtre : la génération continue.",
            VALID: "Lancer la génération"
        },
        PAGES: {
            LABEL: "Pages à garder",
            DOCUMENT: "le document compte {{count}} page(s)",
            FIRST: "Première page",
            ALL: "Toutes",
            CUSTOM: "Choisir",
            CLICK_HINT: "Cliquez sur les pages à garder",
            SELECTED: "Pages gardées : {{pages}}",
            INPUT: "Pages",
            HINT: "Ex. : 1-3, 5",
            INVALID: "Saisie invalide. Ex. : 1-3, 5",
            EMPTY: "Indiquez au moins une page",
            TOO_FAR: "Le document ne compte que {{count}} page(s)"
        },
        CHECK: {
            TITLE: "Vérifier Fichier Epson",
            HOTFOLDER: "Hotfolder",
            FILE: "Fichier",
            PAGES: "Pages",
            CARTOUCHE: "Cartouche",
            YES: "Oui",
            NO: "Non",
            FROM_DELIVERY: "Epson issu du flux de livraison",
            NO_PREVIEW: "Aperçu indisponible",
            VALIDATE: "Envoyer sur l'Epson",
            REJECT: "Refuser le PDF",
            VIEW_TITLE: "PDF Epson",
            FULLSCREEN: "Plein écran",
            CLOSE: "Fermer"
        },
        PAGE: {
            TITLE: "Impressions Epson",
            NEW: "Nouvelle impression",
            IDENTIFIER: "Identifiant",
            EMPTY_FOLDER: "Aucun fichier PDF ou AI dans ce dossier",
            ADD_CARTOUCHE: "Cartouche",
            HISTORY: "Historique",
            STATUS: "Statut",
            ALL: "Tous",
            DATE: "Date",
            PROJECT: "Projet",
            FILE: "Fichier",
            SETTINGS: "Réglages",
            BY: "Demandé par",
            CHECKED_BY: "vérifié par",
            CHECK: "Vérifier",
            FROM_PROOFREADING: "Sur dossier",
            FROM_FILE: "Sur fichier",
            NO_HISTORY: "Aucune impression",
            STEP_PROJECT: "Projet",
            SEARCH_PROJECT: "Rechercher un projet",
            CHANGE: "Changer",
            STEP_FILE: "Flux à lancer",
            SOURCE_PROOFREADING: "PDF EPSON sur Dossier",
            SOURCE_FILE: "PDF EPSON sur fichier AI ou PDF",
            PROOFREADING_HINT: "Flux à lancer sur le dossier enfant : le PDF haute définition cartouché de la dernière relecture de chaque service.",
            NO_PROOFREADING: "Aucune relecture avec un PDF haute définition cartouché",
            FILTER: "Filtrer ce dossier",
            NO_MATCH: "Aucun élément ne correspond au filtre",
            STEP_SETTINGS: "Réglages",
            PREPARE_HINT: "Flux à lancer sur un fichier de production AI ou PDF : calques techniques retirés, pages et cartouche au choix.",
            VIEW: "Voir le PDF",
            VIEW_PRINTED: "Voir le PDF imprimé",
            BACK: "Retour",
            PARENT_FOLDER: "Dossier parent",
            PREVIEW: "Aperçu"
        },
        STATUS: {
            "generating": "En génération",
            "to-check": "À vérifier",
            "printed": "Imprimé",
            "rejected": "Non conforme",
            "error": "Erreur"
        }
    },
    RESET_PROD: {
        BTN: "Réinitialiser la production",
        TITLE: "Réinitialisation de la production",
        TEXT: "Ceci va réinitialiser la relecture à l'etat 'Prêt'."
    },
    UPLOADING: "Chargement",
    UPLOADING_IN_PROGRESS: "Les fichiers sont en train d'être chargés.",
    DOWNLOADING: "Téléchargement",
    DOWNLOADING_IN_PROGRESS: "Les fichiers sont en train d'être téléchargés.",
    ARCHIVING: "Création du zip",
    ARCHIVING_IN_PROGRESS: "Les fichiers sont en train de se charger.",
    ACTUAL_PROJECTS: "Projets en cours",
    ADD_CHILD_PROJECT: "Ajouter projet enfant",
    THUMB: "Vignette",
    JOB_NAME: "Nom du job",
    EXTERN_STATE: "Statut général",
    INTERN_STATE: "Statut interne",
    CREATION_DATE: "Créé par",
    ACTIONS: "Actions",
    ED_JOB: "Projet EasyDiadem",
    DASHBOARDHISTORY: {
        VALIDATIONS_HISTORY: "Historique des validations",
        LOOP: {
            INTERN: "Boucle interne",
            EXTERN: "Boucle externe"
        },
        ORDER: "Ordre",
        PLEASE_SELECT_A_VERSION: "Veuillez sélectionner une version",
        USER: "Utilisateur",
        DATE_HOUR: "Date / heure",
        STATE: "Etat",
        NO_HISTORY: "Aucun historique disponible",
        STEPS: "Etapes",
        MEMBERS: "Membres",
        CATEGORY: "Catégorie",
        CONTROL: "Contrôle"
    },
    VERSION_SHORTNAME: "ver.",
    NO_VERSION: "Pas de version",
    NOT_SENT_TO_CLIENT: "Pas encore envoyée au client, passer par la comparaison interne",
    SPLITVIEWS: "Relectures",
    INTERN_TITLE: "Interne",
    INTERN_TITLE_SHORT: "Int.",
    EXTERN_TITLE: "Externe",
    EXTERN_TITLE_SHORT: "Ext.",
    COMPARE_SHORT: "Comp.",
    RELECTURES: "Relectures",
    SELECT_DOCUMENT_TO_COMPARE: "Sélectionner les versions à comparer",
    DOCUMENT_A: "Version A",
    DOCUMENT_B: "Version B",
    OR: "ou",
    DETAILS: "Détails",
    SEE_PROJECT_HISTORY: "Voir l'historique du projet",
    LAST_MONTH: "Le mois dernier",
    LAST_SIX_MONTHS: "Les six derniers mois",
    LAST_THREE_MONTHS: "Les trois derniers mois",
    LAST_YEAR: "L'an dernier",
    FILTERS: {
        NAME_OR_ID: "Nom ou identifiant",
        START_DATE: "Date début",
        END_DATE: "Date fin",
        REINIT: "Réinitialiser",
        SEARCH: "Recherche",
        PERIOD: "Sélectionner une période"
    },
    RELECTURE: "Relecture",
    YOU_DONT_HAVE_THE_PRIVILEGE: "Vous n'avez pas le privilège",
    EZD_TABLE: {
        TITLE: {
            DATE: "Date",
            CLIENT: "Client",
            REF_REQUEST: "Réf. demande",
            REF_PROJECT: "Réf. projet",
            SOURCE_PROJECT: "Projet d'origine",
            PLANNED_SUB: "Soumission prévue",
            NAME: "Nom de la demande",
            TYPE: "Type de demande",
            INFO: "Info",
            ACTIONS: "Actions"
        }
    },
    RESET_PASSWORD: "Réinitialiser le mot de passe",
    ARE_YOU_SURE_RESET_PASSWORD_TEXT: "Le mot de passe de l'utilisateur {{ username }} sera réinitialisé.",
    ARE_YOU_SURE_RESET_PASSWORD_TEXT_2: "Il recevra son nouveau mot de passe par email.",
    ATTRIBUTES_NAME: {
        TITLE: "Attributs de l'utilisateur",
        CPP: "CPP",
        EXE: "Exe",
        REPRO: "Repro",
        FAB: "Fab",
        OPERATOR: "Opérateur",
        CLIENT: "Client"
    },
    FORGOT_PASSWORD: "Mot de passe oublié ?",
    USERNAME_OR_EMAIL: "Nom d'utilisateur ou email",
    REQUIRED_USERNAME_OR_EMAIL: "Nom d'utilisateur ou email requis",
    ASK_FOR_REINIT: "Demander la réinitialisation",
    ASK_FOR_REINIT_TEXT:
        "Votre demande a bien été prise en compte. Si l'adresse email associée au compte est valide, vous recevrez un email avec un lien pour réinitialiser votre mot de passe.",
    SET_NEW_PASSWORD: "Définir un nouveau mot de passe",
    BACK_TO_LOGIN_PAGE: "Retour à la page de connexion",
    RESET_PASSWORD_DIALOG: {
        ERROR: {
            TITLE: "Une erreur est survenue",
            TEXT: "Merci de vérifier les informations fournies, ou réessayez plus tard."
        },
        REQUEST: {
            SUCCESS: {
                TITLE: "Demande de réinitialisation envoyée",
                TEXT: "Si le nom d'utilisateur ou l'email fourni correspond à un compte existant, vous recevrez un email avec un lien pour réinitialiser votre mot de passe."
            }
        },
        SET: {
            SUCCESS: {
                TITLE: "Mot de passe mis à jour",
                TEXT: "Vous pouvez désormais vous connecter avec votre nom d'utilisateur et votre nouveau mot de passe."
            }
        }
    },
    NEW_USER: "Nouvel utilisateur",
    INVALID_CLIENT: "Client non valide, accedez a cette page depuis la tables des groupes",
    INVALID_MARQUE: "Marque non valide, accedez a cette page depuis la tables des groupes",
    FINISH_SELECTION: "Sélectionner une finition",
    GROUPS_USERS: "Utilisateurs du groupe",
    FIND: "Rechercher",
    SELECT_PAGE_OF_GROUPS: "Sélectionner une page de groupes",
    EX_PRINTER: "Ex. Imprimeur",
    SELECT_PAGE_OF_USERS: "Sélectionner une page d'utilisateurs",
    REQUEST: "Requête",
    NEW_REQUEST_DISCLAIMER:
        "J'ai compris que cette prestation sera intégralement gérée via la plateforme <strong>Easy Diadem</strong>, sans relation directe avec vos contacts habituels chez Diadem. Pour toute demande de prestation jugée trop complexe, ou <strong>en cas de prise de contact autrement que par la plateforme Easy Diadem, Diadem se réserve le droit de réaliser un devis additionnel en fonction de la complexité du travail demandé.</strong>",
    LANG_SELECTION: "Sélection des langues",
    NEW_LANG: "Nouvelle langue",
    LANG_TRANSLATED: "Langue/Language",
    FILE_REDELIVERY_DESC: `Relivraison des fichiers {{ type }} pour le projet {{ projectIdentifier }}`,
    LB: {
        ALL: "Tout",
        WAITING: "En attente de traitement",
        IN_PROGRESS: "Demande en cours",
        DELIVERED: "Livrée",
        CANCELLED: "Annulée",
        INIT: "Elements manquants",
        PENDING: "En attente de traitement",
        PROJECT_LINKED: "Demande en cours",
        CLOSED: "Clôturée"
    },
    CPP: "CPP",
    FAB: "Fab",
    OPERATOR: "Opérateur",
    CLIENT: "Client",
    USER_MANUAL: "Manuel utilisateur",
    LANGS: {
        aa: "Afar",
        ab: "Abkhaze",
        ae: "Avestique",
        af: "Afrikaans",
        ak: "Akan",
        am: "Amharique",
        an: "Aragonais",
        ar: "Arabe",
        as: "Assamais",
        av: "Avar",
        ay: "Aymara",
        az: "Azéri",
        ba: "Bachkir",
        be: "Biélorusse",
        bg: "Bulgare",
        bh: "Bihari",
        bi: "Bichelamar",
        bm: "Bambara",
        bn: "Bengali",
        bo: "Tibétain",
        br: "Breton",
        bs: "Bosnien",
        ca: "Catalan",
        ce: "Tchétchène",
        ch: "Chamorro",
        co: "Corse",
        cr: "Cri",
        cs: "Tchèque",
        cu: "Vieux-slave",
        cv: "Tchouvache",
        cy: "Gallois",
        da: "Danois",
        de: "Allemand",
        dv: "Maldivien",
        dz: "Dzongkha",
        ee: "Ewe",
        el: "Grec moderne",
        en: "Anglais",
        eo: "Espéranto",
        es: "Espagnol",
        et: "Estonien",
        eu: "Basque",
        fa: "Persan",
        ff: "Peul",
        fi: "Finnois",
        fj: "Fidjien",
        fo: "Féroïen",
        fr: "Français",
        fy: "Frison occidental",
        ga: "Irlandais",
        gd: "Écossais",
        gl: "Galicien",
        gn: "Guarani",
        gu: "Gujarati",
        gv: "Mannois",
        ha: "Haoussa",
        he: "Hébreu",
        hi: "Hindi",
        ho: "Hiri motu",
        hr: "Croate",
        ht: "Créole haïtien",
        hu: "Hongrois",
        hy: "Arménien",
        hz: "Héréro",
        ia: "Interlingua",
        id: "Indonésien",
        ie: "Occidental",
        ig: "Igbo",
        ii: "Yi",
        ik: "Inupiak",
        io: "Ido",
        is: "Islandais",
        it: "Italien",
        iu: "Inuktitut",
        ja: "Japonais",
        jv: "Javanais",
        ka: "Géorgien",
        kg: "Kikongo",
        ki: "Kikuyu",
        kj: "Kuanyama",
        kk: "Kazakh",
        kl: "Groenlandais",
        km: "Khmer",
        kn: "Kannada",
        ko: "Coréen",
        kr: "Kanouri",
        ks: "Cachemiri",
        ku: "Kurde",
        kv: "Komi",
        kw: "Cornique",
        ky: "Kirghiz",
        la: "Latin",
        lb: "Luxembourgeois",
        lg: "Ganda",
        li: "Limbourgeois",
        ln: "Lingala",
        lo: "Lao",
        lt: "Lituanien",
        lu: "Luba",
        lv: "Letton",
        mg: "Malgache",
        mh: "Marshallais",
        mi: "Maori de Nouvelle-Zélande",
        mk: "Macédonien",
        ml: "Malayalam",
        mn: "Mongol",
        mo: "Moldave",
        mr: "Marathi",
        ms: "Malais",
        mt: "Maltais",
        my: "Birman",
        na: "Nauruan",
        nb: "Norvégien bokmål",
        nd: "Sindebele",
        ne: "Népalais",
        ng: "Ndonga",
        nl: "Néerlandais",
        nn: "Norvégien nynorsk",
        no: "Norvégien",
        nr: "Nrebele",
        nv: "Navajo",
        ny: "Chichewa",
        oc: "Occitan",
        oj: "Ojibwé",
        om: "Oromo",
        or: "Oriya",
        os: "Ossète",
        pa: "Pendjabi",
        pi: "Pali",
        pl: "Polonais",
        ps: "Pachto",
        pt: "Portugais",
        qu: "Quechua",
        rm: "Romanche",
        rn: "Kirundi",
        ro: "Roumain",
        ru: "Russe",
        rw: "Kinyarwanda",
        sa: "Sanskrit",
        sc: "Sarde",
        sd: "Sindhi",
        se: "Same du Nord",
        sg: "Sango",
        sh: "Serbo-croate",
        si: "Cingalais",
        sk: "Slovaque",
        sl: "Slovène",
        sm: "Samoan",
        sn: "Shona",
        so: "Somali",
        sq: "Albanais",
        sr: "Serbe",
        ss: "Swati",
        st: "Sotho du Sud",
        su: "Soundanais",
        sv: "Suédois",
        sw: "Swahili",
        ta: "Tamoul",
        te: "Télougou",
        tg: "Tadjik",
        th: "Thaï",
        ti: "Tigrigna",
        tk: "Turkmène",
        tl: "Tagalog",
        tn: "Tswana",
        to: "Tongien",
        tr: "Turc",
        ts: "Tsonga",
        tt: "Tatar",
        tw: "Twi",
        ty: "Tahitien",
        ug: "Ouïghour",
        uk: "Ukrainien",
        ur: "Ourdou",
        uz: "Ouzbek",
        ve: "Venda",
        vi: "Vietnamien",
        vo: "Volapük",
        wa: "Wallon",
        wo: "Wolof",
        xh: "Xhosa",
        yi: "Yiddish",
        yo: "Yoruba",
        za: "Zhuang",
        zh: "Chinois",
        zu: "Zoulou",
        mx: "Mexicain",
        fin: "Finlandais"
    },
    SHOOTINGSIDE: {
        FACE: "De Face",
        THREEQUARTERLEFT: "De 3/4 à gauche",
        THREEQUARTERRIGHT: "De 3/4 à droite",
        FACEINCO: "Face légale INCO"
    },
    STATS: {
        // EXE: "Execution",
        // REPRO: "Reprographie",
        REPRO: "Repro",
        EXE: "Exe",
        HD: "HD",
        CREA: "Créa",
        AR: "A/R",
        NBR: "Nbr",
        MOY: "Moyenne",
        INTERN: "Interne",
        EXTERN: "Externe",
        VERSION: "Version",
        VALUES: "Valeurs",
        REF_VALUES: "Valeurs de référence",
        RELECTURE: "Relecture",
        KPI: "KPI",
        GLOBAL_STATS: "Chiffres clefs",
        CUSTOMER_PROD: "Production client",
        NBR_REF: "(Nombre de réfs)",
        SELECT_NOT_ENABLED: "Désactiver la sélection",
        SELECT_ENABLED: "Sélectionner",
        PROJECTS: "Projets",
        DASHBOARD: "Tableau de projets",
        TE0: "Brief Client",
        TE1: "Mise en Production",
        TE2: "(envoi)",
        TEN: "(retour client)",
        TENPLUS1: "Ten+1",
        TP0: "Tp0",
        TP1: "Tp1",
        TP2: "Tp2",
        TPN: "Tpn",
        TPNPLUS1: "Tpn+1",
        NB_AR_INTERN: "Nombre d'Aller-Retour",
        USERS: "Collaborateurs du projet",
        NB_AR_EXTERN: "Nb A/R externe",
        INFOGRAPHISTES: "Infographistes",
        REACT_INTERN_R: "Réactivité Diadem R+",
        REACT_INTERN_V: "Réactivité Diadem V+",
        REACT_CLIENT: "Réactivité Client",
        NB_RELECTURES_CLIENT: "Nombre de relectures client",
        PROJECT: "Ce projet",
        MOY_CHILD_JOB_PARENT: "Moyenne enfants",
        ALL_PROJECTS: "Tous projets",
        JOB_PARENT: "du projet parent",
        MOY_ALL_PROJECTS: "Moyenne tous projets",
        MOY_SELECTION: 'Moy. sélection',
        MOY_TIME: "Temps moyen",
        MOY_TIME_R1: "Remise R1 au Client",
        MOY_TIME_PR: "Entre relecture",
        R_CUSTOMER: "Relecture client",
        MOY_TIME_R_CUSTOMER: "Temps moyen de remise R au client",
        MOY_TIME_RN: "Tps moyen de production entre Rn et Rn+1",
        SELECT_CUSTOMER: "Sélectionner un client pour afficher les données",
        SELECT_BRAND: "Sélectionner une marque pour afficher les données",
        SELECT_BRAND_HINT: "Utilisez les filtres ci-dessus pour choisir une marque et afficher les KPIs de production.",
        CYCLE: "Cycle de Révision",
        DATES: "Dates",
        STEPS: "Steps",
        AVERAGE: "Moyenne Révision",
        TOTAL_REFS: "Total références",
        REFS: "réfs",
        RELECTURES: "relectures",
        VS_AVERAGE: "vs. moy. globale",
        REACT_R1: "Réactivité R1",
        PROD_DURATION: "Production interne",
        AR_RATIO: "Charge interne",
        AR_PER_R: "A/R / relecture",
        TOTAL_DURATION: "Cycle complet",
        FLOW: "Flux",
        TOP_PROJECTS: "Moins de relectures",
        FLOP_PROJECTS: "Plus de relectures",
        TOOLTIP: {
            TE0: "Date réception Brief Client ",
            TE1: "Date de mise en production",
            TE2: "Date de validation de la relecture par le CPP",
            TEN: "Date de retour du Client sur la Rn",
            TENPLUS1: "Date de remise de la Rn+1 au Client ",
            TP0: "Date à laquelle l’exe a été validée – ou date de mise en production Repro",
            TP1: "Date de remise de la Rp1",
            TP2: "Date de validation de la relecture par le CPP",
            TPN: "Date de retour du Client sur la Rpn",
            TPNPLUS1: "Date de remise de la Rpn+1 au Client",
            KPI: "Moyenne du temps pour la remise au client",
            KPI2: "Temps de retour client sur la première relecture (Te2 → Ten)",
            NB_R: "Nombre total de relectures client validées",
            PROD_DURATION: "Durée de production interne avant le premier envoi au client (Te1 → Te2)",
            AR_RATIO: "Nombre moyen d'allers-retours internes par relecture client (Nb_AR_intern / Nb_R)",
            TOTAL_DURATION: "Durée totale du projet, du brief à la livraison finale (Te0 → livraison)",
            REF_VALUES: "Pour tous les projets du client"
        }
    },
    INFORMATION_TO_COME: "Information à venir",
    SIZE: "Taille",
    ARCHIVES: {
        MANAGE: "Gérer les archives",
        FAILED_TITLE: "Archivage partiel",
        FAILED_TEXT: "Les projets suivants n'ont pas pu être archivés :",
        FAILED_UNKNOWN: "Erreur inconnue",
        SELECT_ALL: "Tous sélectionner",
        DESELECT_ALL: "Tout désélectionner",
        INACTIVE: "Projets inactifs",
        REPORTS: "Rapports d'archivage",
        BIRTH_DATE: "Date de création",
        INACTIVE_DURATION: "Durée d'inactivité",
        UNITS: "en jours",
        SUBMIT: "Rechercher",
        NAME_OR_ID: "Nom ou ID de projet",
        ARCHIVED: "Archivés",
        UNARCHIVED: "Désarchivés",
        DATE: "Date",
        AUTHOR: "Auteur",
        SCHEDULE_STATE: "Etat de l'archivage",
        CANCEL_SCHEDULE: "Annuler la programmation",
        CONFIRM_CANCEL_ARCHIVE: "L'archivage programmé sera annulé et le projet retrouvera l'état qu'il avait avant sa mise en file d'attente. Aucun fichier n'est déplacé.",
        CONFIRM_CANCEL_UNARCHIVE: "Le désarchivage programmé sera annulé et le projet restera archivé. Aucun fichier n'est déplacé.",
        CANCEL_ARCHIVE_OK: "Archivage programmé annulé. Le projet a retrouvé son état précédent.",
        CANCEL_UNARCHIVE_OK: "Désarchivage programmé annulé. Le projet reste archivé.",
        CANCEL_KO: "L'annulation a échoué. La demande reste en file d'attente.",
        ARCHIVE_NOW: "Archiver maintenant",
        SCHEDULE_ARCHIVE: "Programmer l'archivage",
        UNARCHIVE_NOW: "Désarchiver maintenant",
        SCHEDULE_UNARCHIVE: "Programmer le désarchivage",
        CONFIRM_ARCHIVE: "Les fichiers du projet seront copiés vers les archives, puis retirés de la production.",
        CONFIRM_UNARCHIVE: "Les fichiers du projet seront restaurés en production.",
        SCHEDULE_HINT: "« Programmer » place le projet en file d'attente : l'opération sera effectuée lors du traitement automatique du samedi à minuit.",
        SCHEDULED_ARCHIVE_OK: "Archivage programmé. Il sera effectué lors du traitement automatique du samedi à minuit.",
        SCHEDULED_UNARCHIVE_OK: "Désarchivage programmé. Il sera effectué lors du traitement automatique du samedi à minuit.",
        SCHEDULED_ARCHIVE_KO: "La programmation de l'archivage a échoué. Rien n'a été modifié.",
        SCHEDULED_UNARCHIVE_KO: "La programmation du désarchivage a échoué. Rien n'a été modifié.",
        ARCHIVE_OK: "Projet archivé.",
        UNARCHIVE_OK: "Projet désarchivé.",
        ARCHIVE_KO: "L'archivage a échoué. Aucun fichier n'a été supprimé.",
        UNARCHIVE_KO: "Le désarchivage a échoué. Le projet reste archivé.",
        SCHEDULED: "Programmée",
        UNSCHEDULED: "Effectuée",
    }
};
